import {
  FJVideo,
  FJAudio,
  FJWidget,
  FJMultiWidget,
  FJIntroWidget,
  FJSvg,
  FJAnimationCanvas,
  FJImage,
  FJBackgroundColor,
  FJAnimationManager,
  FJFontManager,
  FJConstant,
  FJExportStore,
  FJOverlayManager,
  FJDynamicLogoManager,
  FJTransition,
  FJPhotoAnimationStore,
} from "fj-graph";
import {FJDecoderManager, FJEncoderManager} from "fj-codec";
import FJTimelineStore from "fj-timeline";
import FJCoreUtil from "../core/util/FJCoreUtil";
import FJMediaStore from "./FJMediaStore";
import FJMediaCacheStore from "./FJMediaCacheStore";
import FJUtil from "../util/FJUtil";
import FJCoreConstant from '../core/constant/FJCoreConstant'
import FJConfig from "../config/FJConfig";
import JSZip from 'jszip'
import FileSaver from 'file-saver'
import _ from 'lodash'
import FJSaveStore from "./FJSaveStore";
import FJNetworkStore from "./FJNetworkStore";
import FJMessageStore from "./FJMessageStore";
import FJLocalStore from "./FJLocalStore";
import FJMedia from "./FJMedia";
import FJUndoStore from "./FJUndoStore";
import FJEventConstant from "../constant/FJEventConstant";
import FJIntroOutroStore from "./FJIntroOutroStore";
import FJElementStore from "./FJElementStore";
import FJDecorationOverlayStore from "./FJDecorationOverlayStore";
import FJDecorationOverlay from "fj-graph/src/graph/decorationOverlay/FJDecorationOverlay";
import FJViewConstant from "../constant/FJViewConstant";
import FJSvgStore from "./FJSvgStore";
import key from "keymaster";
import FJCanvasManager from "../core/FJCanvasManager";
import FJVideoManager from "../core/FJVideoManager";
import FJActionConstant from "../constant/FJActionConstant";
import lzutf8 from "lzutf8";
import FJMediaDownloadStore from "./FJMediaDownloadStore";
import FJShareStore from "./FJShareStore";
import FJCloudStore from "./FJCloudStore";

let FJCanvasStore = (function () {

  const COMMANDS = {
    SET_EDITOR: 'SET_EDITOR',
    SELECT_ITEM: 'SELECT_ITEM',
    GET_ALL_TRACK_DATA: 'GET_ALL_TRACK_DATA',
    DRAG_TIMELINE: 'DRAG_TIMELINE',
    ADD_TIMELINE: 'ADD_TIMELINE',
    INIT_CANVAS: 'INIT_CANVAS',
    UPDATE_CANVAS_SIZE: 'UPDATE_CANVAS_SIZE',
    IS_PLAYING: 'IS_PLAYING',
    PLAY: 'PLAY',
    PAUSE: 'PAUSE',
    SEEK: 'SEEK',
    RENDER_THUMBNAIL: 'RENDER_THUMBNAIL',
    GET_ALL_DURATION: 'GET_ALL_DURATION',
    GET_EXPORT_PREVIEW_DURATION: 'GET_EXPORT_PREVIEW_DURATION',
    GET_CURRENT_TIME: 'GET_CURRENT_TIME',
    GET_PROGRESS: 'GET_PROGRESS',
    GET_GRAPHS_BY_ID: 'GET_GRAPHS_BY_ID', // 返回时间轴中是否使用了含有id的对象
    GET_GRAPHS_BY_SOURCE_ID: 'GET_GRAPHS_BY_SOURCE_ID', // 返回时间轴中是否使用了含有SourceId的对象
    DELETE_GRAPHS_BY_SOURCE_IDS: 'DELETE_GRAPHS_BY_SOURCE_IDS', // 删除时间轴中含有SourceId的对象
    ADD_SUBLAYER_TIMELINE: 'ADD_SUBLAYER_TIMELINE', // 添加到副轴
    SET_GRAPH_DELAY_BY_ID: 'SET_GRAPH_DELAY_BY_ID', // 根据GRAPHID 设置delay
    DELETE_GRAPHS_BY_ID: 'DELETE_GRAPHS_BY_ID', // 根据id删除时间轴中的对象
    RERENDER: 'RERENDER',
    EXPORT: 'EXPORT', // 开始输出
    EXPORT_CANCEL: 'EXPORT_CANCEL', // 退出输出
    DOWNLOAD_EXPORT_VIDEO: 'DOWNLOAD_EXPORT_VIDEO', // 再次下载输出的video
    CLEAR_CACHE_VIDEO: 'CLEAR_CACHE_VIDEO', // 清除输出的video
    SUBSCRIBE_SELECTION: 'SUBSCRIBE_SELECTION', // 监听预览区域 取消和点击选中的
    SUBSCRIBE_PAUSE: 'SUBSCRIBE_PAUSE', // 监听预览区域点击
    CHANGE_PROJECT_NAME: 'CHANGE_PROJECT_NAME', // 修改工程名
    DECODE_CANVAS: 'DECODE_CANVAS',
    SAVE_FOR_ONLINE: 'SAVE_FOR_ONLINE', // 在线保存
    LOAD_FOR_ONLINE: 'LOAD_FOR_ONLINE', // 在线读取
    SAVE_FOR_LOCAL: 'SAVE_FOR_LOCAL', // 本地保存
    LOAD_FOR_LOCAL: 'LOAD_FOR_LOCAL', // 本地读取
    INIT_UNDO: 'INIT_UNDO', // 初始化undo
    CLEAR_UNDO: 'CLEAR_UNDO', // 清除undo
    SPLIT_TIMELINE: 'SPLIT_TIMELINE', // 切割时间线
    GET_TIMELINE_IS_ELE: 'GET_TIMELINE_IS_ELE', // 是否显示 Split
    SET_MEDIA_LIBRARY: 'SET_MEDIA_LIBRARY',
    SET_TEXT_ANIMATION_DATA: 'SET_TEXT_ANIMATION_DATA',
    SET_WIDGET_DATA: 'SET_WIDGET_DATA',
    SET_WATERMARK_DATA: 'SET_WATERMARK_DATA',
    SET_OVERLAY_DATA: 'SET_OVERLAY_DATA',
    SET_DECORATION_OVERLAY_DATA: 'SET_DECORATION_OVERLAY_DATA',
    SET_SVG_DATA: 'SET_SVG_DATA',
    SET_VIDEO_ATTRIBUTES_DATA: 'SET_VIDEO_ATTRIBUTES_DATA',
    SET_AUDIO_ATTRIBUTES_DATA: 'SET_AUDIO_ATTRIBUTES_DATA',
    SET_PHOTO_ATTRIBUTES_DATA: 'SET_PHOTO_ATTRIBUTES_DATA',
    SET_MEDIA_OPACITY_DATA: 'SET_MEDIA_OPACITY_DATA',
    TOGGLE_EDIT_MODE: 'TOGGLE_EDIT_MODE',
    GET_SELECTED_AND_IS_RENDER_GRAPH: 'GET_SELECTED_AND_IS_RENDER_GRAPH', // 得到选中的graph并且得在当前时间内
    GET_SELECTED_AND_COULD_OPERATE_EDIT: 'GET_SELECTED_AND_COULD_OPERATE_EDIT',
    GET_WATERMARK: 'GET_WATERMARK',
    SUBSCRIBE_DOUBLE_CLICK_IN_TRACK: 'SUBSCRIBE_DOUBLE_CLICK_IN_TRACK', // 双击track里面
    RE_SEEK_AND_RENDER: 'RE_SEEK_AND_RENDER',
    RENDER_CACHE: 'RENDER_CACHE',
    RENDER_COVER: 'RENDER_COVER',
    SET_PROJECT_ID: 'SET_PROJECT_ID',
    UPDATE_GRAPH_URL: 'UPDATE_GRAPH_URL', // 更新graph的URL，主要用于link获取延迟更新资源的情况
    GET_VIDEO_EDITOR: 'GET_VIDEO_EDITOR',
    GET_PROJECT_NAME: 'GET_PROJECT_NAME',
    GET_PROJECT_ID: 'GET_PROJECT_ID',
    GET_SELECTED_GRAPH_CENTER_TIME: 'GET_SELECTED_GRAPH_CENTER_TIME',
    UPDATE_GRAPH_MEDIA_STATUS: "UPDATE_GRAPH_MEDIA_STATUS",  // 更新graph的mediaStatus，主要用于link获取延迟更新资源的情况
    CLEAR_LOGIN_TO_SAVE_TIMER: "CLEAR_LOGIN_TO_SAVE_TIMER",
    GET_ALL_GRAPHS: 'GET_ALL_GRAPHS',
    SET_BACKGROUND_COLOR_ATTRIBUTES_DATA: 'SET_BACKGROUND_COLOR_ATTRIBUTES_DATA',
    GET_COPY_STATUS: 'GET_COPY_STATUS',
    GET_PASTE_STATUS: 'GET_PASTE_STATUS',
    CLEAR_COPY_CACHE: 'CLEAR_COPY_CACHE',
    COPY: 'COPY',
    PASTE: 'PASTE',
    GET_MAIN_LAYER_VOLUME: 'GET_MAIN_LAYER_VOLUME',
    SET_MAIN_LAYER_VOLUME: 'SET_MAIN_LAYER_VOLUME',
    CLEAR_IGNORES_RENDER: 'CLEAR_IGNORES_RENDER',
    SET_GRAPH_CROP_MODE: 'SET_GRAPH_CROP_MODE',
    SET_GRAPH_CROP_TYPE: 'SET_GRAPH_CROP_TYPE',
    APP_CONTENT_MOUSE_DOWN: 'APP_CONTENT_MOUSE_DOWN',
    ADD_INTRO_ANIMATION_SLOT: 'ADD_INTRO_ANIMATION_SLOT',
    ADD_OUTRO_ANIMATION_SLOT: 'ADD_OUTRO_ANIMATION_SLOT',
    REMOVE_INTRO_ANIMATION_SLOT: 'REMOVE_INTRO_ANIMATION_SLOT',
    REMOVE_OUTRO_ANIMATION_SLOT: 'REMOVE_OUTRO_ANIMATION_SLOT',
    SET_TRANSFORM: 'SET_TRANSFORM',
    DELETE_TRANSITION: 'DELETE_TRANSITION',
    UPDATE_TRANSITION: 'UPDATE_TRANSITION',
    ABORT_DRAG_TRANSITION: 'ABORT_DRAG_TRANSITION',
    DRAG_TRANSITION: 'DRAG_TRANSITION',
    MOVE_OUT_TIMELINE_SPECIAL_TREATMENT: 'MOVE_OUT_TIMELINE_SPECIAL_TREATMENT',
    RETRY_WATERMARK: 'RETRY_WATERMARK',
    ENABLE_FILTER: 'ENABLE_FILTER',
    DISABLE_FILTER: 'DISABLE_FILTER',
    ENABLE_ADJUST: 'ENABLE_ADJUST',
    SET_FILTER_DATA: 'SET_FILTER_DATA',
    SET_ADJUST_DATA: 'SET_ADJUST_DATA',
    DECODE_MEDIA_TO_GRAPH: 'DECODE_MEDIA_TO_GRAPH',
    ENABLE_INTRO: 'ENABLE_INTRO',
    DISABLE_INTRO: 'DISABLE_INTRO',
    UPDATE_INTRO: 'UPDATE_INTRO',
    SHARE_TO_YOUTUBE: 'SHARE_TO_YOUTUBE',
    SHARE_TO_YOUTUBE_CANCEL: 'SHARE_TO_YOUTUBE_CANCEL',
    SHARE_TO_DROPBOX: 'SHARE_TO_DROPBOX',
    SHARE_TO_DROPBOX_CANCEL: 'SHARE_TO_DROPBOX_CANCEL',
    SET_EXPORT_PREVIEW_GLOBAL_VOLUME: 'SET_EXPORT_PREVIEW_GLOBAL_VOLUME',
    GET_RATIO: 'GET_RATIO',
    SET_RATIO: 'SET_RATIO',
    BIND_EXPORT_PREVIEW: 'BIND_EXPORT_PREVIEW',
    UNBIND_EXPORT_PREVIEW: 'UNBIND_EXPORT_PREVIEW',
    HAS_EXPORT_PREVIEW: 'HAS_EXPORT_PREVIEW',
  };
  const ADSORPTION_VALUE = 6;

  let _isOperating = null;
  let _keyCopeBeforeOperate = null;
  let _saveTimer = null;
  let _isPlaying = false;
  let _recordProjectDataString = '';
  let _recordCurrentTime = -1;
  let _previewForDragDebounce = _.debounce(previewForDrag, 100);
  let _youtubeCacheId = '';
  let _globalVolumeCache = 1;
  let _recordCropData = null;
  let _playingCallback = () => {
  };

  /**
   * @description 渲染封面
   */
  const renderCover = (function () {
    let _recordCanvas = document.createElement('canvas'); // 渲染工程封面
    _recordCanvas.width = 320;
    _recordCanvas.height = 180;
    let _recordCtx = _recordCanvas.getContext('2d');
    let _recordKey = '';
    return async function () {
      let key = '';
      let size = {width: _recordCanvas.width, height: _recordCanvas.height};
      let {mainLayer, subLayer} = canvas.getAllLayer();
      let renderIds = [...mainLayer, ...subLayer].filter(id => {
        let graph = canvas.getGraphById(id);
        return graph.getDelay() === 0;
      });

      renderIds.forEach(id => {
        let graph = canvas.getGraphById(id);
        let type = graph.type || '';
        let sourceId = graph.sourceId || '';
        let startTime = graph.getStartTime() || 0;
        key += (type.toString() + sourceId.toString() + startTime.toString());
      });

      if (key !== _recordKey) {
        let graphs = renderIds.map(id => canvas.getGraphById(id));
        let length = graphs.length;
        let ctx = _recordCanvas.getContext('2d');
        ctx.save();
        ctx.fillStyle = "#000000";
        ctx.fillRect(0, 0, size.width, size.height);
        ctx.restore();
        canvas.renderBackground();
        for (let i = 0; i < length; i++) {
          let cloneGraph = graphs[i].clone();
          if (cloneGraph.getMediaStatus && cloneGraph.getMediaStatus() !== FJMedia.MediaStatus().SUCCESS) {
            continue;
          }
          try {
            if (!cloneGraph.isEnableMedia()) {
              await cloneGraph.enableMedia();
            }
            await cloneGraph.seek(0);
            let {
              IMAGE, VIDEO, TEXT_ANIMATION, BACKGROUND,
              WIDGET, MULTI_WIDGET, OVERLAY, DECORATION_OVERLAY, DYNAMIC_LOGO, SVG
            } = FJCoreConstant;
            let canvas = null;
            let view = document.createElement('div');
            view.style.cssText = `
              position: absolute;
              z-index: -1;
              width: ${size.width}px; 
              height: ${size.height}px`;
            document.body.appendChild(view);
            switch (cloneGraph.type) {
              case IMAGE:
              case VIDEO:
              case BACKGROUND:
              case WIDGET:
              case MULTI_WIDGET:
              case OVERLAY:
              case DYNAMIC_LOGO:
              case DECORATION_OVERLAY:
              case SVG:
              case TEXT_ANIMATION:
                cloneGraph.render(view);
                try {
                  if (cloneGraph.renderToCanvasWithView) {
                    canvas = await cloneGraph.renderToCanvasWithView(view);
                  } else {
                    canvas = await FJCoreUtil.htmlToCanvas(view)
                  }
                  _recordCtx.drawImage(canvas, 0, 0, size.width, size.height);
                } catch (e) {
                  console.log(e);
                }
                view.parentNode.removeChild(view);
                break;
              default:
            }
          } catch (e) {
            console.log(e);
          }
        }
      }

      return _recordCanvas;
    }
  })();

  let canvas = new FJAnimationCanvas({
    maxLimitTime: FJConfig.maxLimitTime,
    trackNodeSelectedFillColor: FJConfig.trackNodeSelectedFillColor,
    cursors: {
      rotate: `url(${FJConfig.iconPath}rotate.cur?v=${FJConfig.version}), auto`,
    }
  });
  let exportPreviewCanvas = null;

  /**
   * @description 返回主轴中元素的总时长
   * @param {Array} layer
   * @param {boolean} allowBlock 是否允许元素之间有间隔
   * @return {*}
   */
  function getLayerDuration(layer, allowBlock) {
    let graphs = canvas.getGraphsInLayer(layer);
    if (allowBlock) {
      let tailGraph = graphs[graphs.length - 1];
      return tailGraph ? tailGraph.getDelay() + tailGraph.duration : 0;
    } else {
      return graphs.reduce((value, graph) => {
        return value + graph.duration;
      }, 0);
    }
  }

  /**
   * @description 是否含有音频
   * @return {*}
   */
  function hasAudioForExport() {
    return !!canvas.getAllGraphs().find(graph => (graph.hasAudioTrack && graph.hasAudioTrack()));
  }

  /**
   * @description 返回所有选中对象的id
   * @return {Array}
   */
  function allSelectedId() {
    return canvas
      .getAllGraphs()
      .filter(graph => graph.isSelected())
      .map(graph => graph.id);
  }

  /**
   * @description 创建graph
   * @param type
   * @param graphData
   * @param options
   * @param options.justCreate
   * @return {null}
   */
  function createGraph(type, graphData, options) {
    let {
      VIDEO,
      AUDIO,
      TEXT_ANIMATION,
      IMAGE,
      BACKGROUND,
      WIDGET,
      MULTI_WIDGET,
      INTRO_WIDGET,
      SVG,
      DYNAMIC_LOGO,
      OVERLAY,
      DECORATION_OVERLAY
    } = FJCoreConstant;
    let graph = null;
    if (graphData.sourceId) {
      FJMediaStore.updateUsedMediaId(graphData.sourceId);
    }
    switch (type) {
      case VIDEO:
        graph = new FJVideo(graphData);
        break;
      case AUDIO:
        graph = new FJAudio(graphData);
        break;
      case TEXT_ANIMATION:
        graph = FJAnimationManager.createAnimation(options.name, graphData);
        break;
      case IMAGE:
        graph = new FJImage(graphData);
        break;
      case BACKGROUND:
        graph = new FJBackgroundColor(graphData);
        break;
      case WIDGET:
        graph = new FJWidget({...graphData, name: options.name});
        break;
      case MULTI_WIDGET:
        graph = new FJMultiWidget({...graphData, name: options.name});
        break;
      case INTRO_WIDGET:
        graph = new FJIntroWidget({...graphData, name: options.name});
        break;
      case SVG:
        graph = new FJSvg({...graphData, name: options.name});
        break;
      case DECORATION_OVERLAY:
        graph = new FJDecorationOverlay({...graphData, name: options.name});
        break;
      case OVERLAY:
        graph = FJOverlayManager.createOverlay(options.name, graphData);
        break;
      case DYNAMIC_LOGO:
        graph = FJDynamicLogoManager.createLogo(options.name, graphData);
        break;
      default:
    }

    if (graph) {
      if (!options || !options.justCreate) {
        let layer = options && options.layer;
        canvas.add(graph);
        canvas.addToLayer(layer || canvas.getAllLayer().mainLayer, graph.id);
      }
      initGraphEvent(graph);
      return graph;
    }
  }

  /**
   * @description 绑定graph事件
   * @param graph
   */
  function bindGraphEvents(graph) {
    let {
      GRAPH_MOVED,
      GRAPH_RESIZED,
      GRAPH_ROTATED,
      GRAPH_SELECTED,
      GRAPH_DESELECTED,
      GRAPH_CROP_MODE_EXIT,
      DOUBLE_CLICK,
      GRAPH_INIT_RELATIVERECT,
    } = FJConstant;
    let graphTransformedFunc = (graph) => {
      if (!graph.getCropMode()) {
        addUndo(graph.id);
        saveOnline();
      }
    };
    let graphExitCropFunc = (graph) => {
      graphTransformedFunc(graph);
      canvas.reRender(true);
    };
    let updateToolbarFunc = () => {
      setTimeout(() => {
        window.FJEvent.dispatch('updateToolbar');
      }, 0);
    };
    let doubleClickFunc = (graph) => {
      let index = 0;
      let {TEXT, OVERLAY, DYNAMIC_LOGO} = FJCoreConstant;
      if (graph.type === FJCoreConstant.TEXT) {
        let onwer = graph.owner;
        if (onwer) {
          switch (onwer.type) {
            case OVERLAY:
            case DYNAMIC_LOGO:
              onwer.getGraphsByType(TEXT).forEach((graph, idx) => {
                if (graph.isSelected()) {
                  index = idx;
                }
              });
              break;
            default:
          }
        }
      }
      window.FJEvent.dispatch('doubleClickInTrack', index)
    };
    graph.on(GRAPH_MOVED, graphTransformedFunc);
    graph.on(GRAPH_RESIZED, (graph) => {
      graphTransformedFunc(graph);
      updateToolbarFunc();
    });
    graph.on(GRAPH_ROTATED, (graph) => {
      graphTransformedFunc(graph);
      updateToolbarFunc();
    });
    graph.on(GRAPH_CROP_MODE_EXIT, graphExitCropFunc);
    graph.on(GRAPH_SELECTED, updateToolbarFunc);
    graph.on(GRAPH_INIT_RELATIVERECT, updateToolbarFunc);
    graph.on(GRAPH_DESELECTED, (graph) => {
      let {VIDEO, IMAGE} = FJCoreConstant;
      let {id, type} = graph;
      updateToolbarFunc();

      // 主轴视频/图片在取消选中时需要禁用自由编辑
      if (FJConfig.enableMainTrackEditMode && canvas.getAllLayer().mainLayer.includes(id) && (type === VIDEO || type === IMAGE)) {
        graph.setControlEnable(false);
      }
    });
    graph.on(DOUBLE_CLICK, doubleClickFunc);
  }

  /**
   * @description 初始化graph事件
   * @param graph
   */
  function initGraphEvent(graph) {
    bindGraphEvents(graph);
    if (graph.isGroup()) {
      graph.forEachGraph(graph => bindGraphEvents(graph));
    }
  }

  /**
   * @description 设置graph的RelativeRect，
   * @param graph {Object}
   * @param scale {Number} 缩放尺寸
   */
  function setRelativeRectByScale(graph, scale) {
    let relativeRect = graph.getRelativeRect();
    let center = FJCoreUtil.calcCenterRect(relativeRect);
    let rect = {
      ...relativeRect,
      width: scale,
      height: scale / relativeRect.width * relativeRect.height,
    };
    graph.setRelativeRect(FJCoreUtil.locationCenterToPoint(rect, center));
  }

  /**
   * 工程保存提示提示
   */
  function loginToSaveTimer() {
    if (_saveTimer) {
      return;
    }

    _saveTimer = setTimeout(() => {

      if (FJUtil.isAnonymousProject()) {
        // 弹出登陆提示
        window.FJEvent.dispatch('showSaveTipModal');
      }
    }, 20000);
  }

  /**
   * @description 清除工程保存提示提示
   */
  function clearLoginToSaveTimer() {
    clearTimeout(_saveTimer);
  }

  /**
   * @description 在线更新
   * @param id
   * @param data
   * @return {Promise<unknown>}
   */
  function updateOnline(id, data) {
    return FJNetworkStore.updateProject(id, data);
  }

  /**
   * @description 加载工程字体
   * @param {*} projectData
   */
  function loadProjectFont(projectData) {
    let promises = [];
    let {TEXT_ANIMATION, OVERLAY, DYNAMIC_LOGO} = FJCoreConstant;
    let textAnimationFonts = [];
    let pushFont = (fontFamily) => {
      if (!textAnimationFonts.includes(fontFamily)) {
        textAnimationFonts.push(fontFamily);
      }
    };

    projectData.graphs.forEach(graph => {
      let graphType = graph.type;
      if (graphType === TEXT_ANIMATION) {
        pushFont(graph.fontFamily);
      } else if (graph.type === OVERLAY || graph.type === DYNAMIC_LOGO) {
        graph.texts.forEach(text => pushFont(text.fontFamily));
      }
    })

    textAnimationFonts.forEach(fontFamily => {
      promises.push(new Promise(resolve => {
        FJFontManager.loadFont(fontFamily, resolve);
      }))
    });

    let watermarkText = projectData.watermark && projectData.watermark.watermarkText;
    if (watermarkText) {
      let {fontFamily} = watermarkText;
      if (fontFamily) {
        promises.push(new Promise(resolve => {
          FJFontManager.loadFont(fontFamily, resolve)
        }));
      }
    }

    return Promise.all(promises);
  }

  /**
   * @description 新建时间线
   * @param data
   * @param {boolean} flush 是否是点击添加
   * @return {null|*}
   */
  function newTimeline(data, flush) {
    let graph = null;
    let {type, fromType, value, media, duration} = data;
    let {mainLayer, subLayer, subAudioLayer} = canvas.getAllLayer();
    let url = media && media.getMediaCache() && media.getMediaCache().getUrl();
    let videoInfo = media && {
      rotation: media.rotation,
      ...media.size,
    };
    let currentDuration = media && media.duration || duration;
    let mediaStatus = media && media.getStatus();
    let {
      VIDEO,
      AUDIO,
      TEXT_ANIMATION,
      IMAGE,
      BACKGROUND,
      WIDGET,
      MULTI_WIDGET,
      SVG,
      OVERLAY,
      DECORATION_OVERLAY,
      DYNAMIC_LOGO
    } = FJCoreConstant;
    let commonGraphData = {
      owner: canvas,
      startTime: 0,
      endTime: (media && media.duration) || duration || FJConfig.fixedDuration,
    };
    let __layer = subLayer;
    if (flush) {
      let __mainLayerDuration = getLayerDuration(mainLayer);
      let __curDuration = FJCoreUtil.toFixed(commonGraphData.endTime - commonGraphData.startTime, 2);
      let __delay = FJCoreUtil.toFixed(canvas.currentTime - __curDuration / 2, 2);
      __delay = Math.max(0, __delay);
      commonGraphData.delay = __delay;
      if (type === VIDEO || type === IMAGE || type === BACKGROUND
        || __delay > __mainLayerDuration || __mainLayerDuration === 0) {
        __layer = mainLayer;
      }
    }
    switch (type) {
      case VIDEO: {
        graph = createGraph(type, {
          ...commonGraphData,
          sourceId: value,
          mediaStatus,
          url,
          videoInfo,
          originDuration: currentDuration,
        }, {layer: __layer});
        break;
      }
      case AUDIO: {
        if (mainLayer.length === 0) {
          FJMessageStore.addMessage(FJLocalStore._('main-resource-tip'), 'error');
          return;
        }
        graph = createGraph(type, {
          ...commonGraphData,
          sourceId: value,
          url,
          mediaStatus,
          originDuration: currentDuration,
        }, {layer: subAudioLayer});
        break;
      }
      case IMAGE: {
        graph = createGraph(type, {
          ...commonGraphData,
          sourceId: value,
          url,
          mediaStatus,
          originDuration: FJConfig.fixedDuration,
          animationType: FJPhotoAnimationStore.allAnimation()[0].type,
        }, {layer: __layer});
        break;
      }
      case OVERLAY:
      case DYNAMIC_LOGO:
      case TEXT_ANIMATION: {
        graph = createGraph(type, {
          ...commonGraphData,
        }, {
          name: value,
          layer: __layer,
        });

        // 此处是特殊渲染，目的是使得动态logo里的image正确计算出位置、尺寸信息
        // 在替换logo时会用到这个数据
        if (type === DYNAMIC_LOGO) {
          graph.enableMedia().then(() => {
            graph.renderCache();
          }).catch(e => console.log(e));
        }

        // 统计
        if (type === OVERLAY) {
          FJUtil.ealog('app_overlay_use', {
            overlay_categary: 'overlay for text',
          });
        } else if (type === DYNAMIC_LOGO) {
          FJUtil.ealog('app_overlay_use', {
            overlay_categary: 'logo/intro/outro',
          });
        } else if (type === TEXT_ANIMATION) {
          let {simple, dynamic} = FJAnimationManager.allAnimations();
          let __value = '';
          if (simple.find(item => item.name === value)) {
            __value = 'simple text';
          } else if (dynamic.find(item => item.name === value)) {
            __value = 'dynamic text';
          }
          FJUtil.ealog('app_text_use', {
            text_categary: __value,
          });
        }

        break;
      }
      case BACKGROUND: {
        graph = createGraph(type, {
          ...commonGraphData,
          backgroundColor: value,
        }, {
          backgroundColor: value,
          layer: __layer,
        });
        break;
      }
      case WIDGET:
      case MULTI_WIDGET:
      case DECORATION_OVERLAY:
        graph = createGraph(type, {
          ...commonGraphData,
          ...data.elementData,
        }, {
          name: value,
          layer: __layer,
        });
        if (type === DECORATION_OVERLAY) {
          FJUtil.ealog('app_overlay_use', {
            overlay_categary: 'overlay for decoration',
          });
        } else if (type === WIDGET || type === MULTI_WIDGET) {
          FJUtil.ealog('app_widget_use', {
            widget_state: 'self-built dynamic',
            widget_categary: FJElementStore.getCategoryByName(value, type),
          });
        }
        break;
      case SVG: {
        let {elementData: svg} = data;
        let elementData = fromType === FJViewConstant.SVG_WEB && svg ? {svgString: FJSvgStore.svgToString(svg)} : {};
        let colorData = fromType === FJViewConstant.SVG_WEB ? {colors: ['#FFFFFF']} : {};
        graph = createGraph(type, {
          ...commonGraphData,
          ...elementData,
          ...colorData,
          svg: svg,
          fromType,
        }, {
          name: value,
          layer: __layer,
        });

        let __stateValue = '';
        let __categoryValue = '';
        if (fromType === FJViewConstant.SVG_WEB) {
          __stateValue = 'third-party static';
        } else {
          __stateValue = 'self-built static';
          __categoryValue = FJElementStore.getCategoryByName(value);
        }
        FJUtil.ealog('app_widget_use', {
          widget_state: __stateValue,
          widget_categary: __categoryValue,
        });
        break;
      }
      default:
    }
    let id = graph && graph.id;
    decodeToTimeline();
    FJTimelineStore.newTimeline(id, flush);
    encodeFromTimeline(true);

    if (flush) {
      addUndo(id);
      saveOnline();
    }

    // 新增的对象
    if (FJConfig.enableMainTrackEditMode && canvas.getAllLayer().mainLayer.includes(id) && (type === VIDEO || type === IMAGE)) {
      graph.setControlEnable(false);
    }

    let {STOCK} = FJMedia.MediaFromType();
    if (fromType === STOCK) {
      switch (type) {
        case VIDEO:
          FJUtil.ealog('timeline_stock_media_use', {type: 'video'})
          break;
        case AUDIO:
          FJUtil.ealog('timeline_stock_media_use', {type: 'audio'})
          break;
        case IMAGE:
          FJUtil.ealog('timeline_stock_media_use', {type: 'photo'})
          break;
        default:
      }
    }

    return id;
  }

  /**
   * @description 在线保存
   * @param flush
   */
  function saveOnline(flush) {
    let curData = canvas.encode();
    let curDataString = JSON.stringify(curData);
    if (curDataString !== _recordProjectDataString || flush) {
      _recordProjectDataString = curDataString;
      FJSaveStore.save(canvas.getKey(), _.cloneDeep(curData), flush);
      if (FJUtil.isAnonymousProject()) {
        loginToSaveTimer();
      }
    }
  }

  /**
   * @description 添加undo处理
   * @param graphId
   */
  function addUndo(graphId) {
    let {state} = FJUndoStore.get();
    let curUndoDataString = JSON.stringify(state);
    let data = canvas.encode();
    try {
      let stateString = JSON.stringify(data);
      if (stateString !== curUndoDataString) {
        FJUndoStore.pushSync(data, graphId);
      }
    } catch (e) {
      clearUndo();
    }

  }

  /**
   * @description 清除undo
   */
  function clearUndo() {
    FJUndoStore.clear();
    addUndo();
  }

  function decodeMediaToGraph(graph) {
    let {type} = graph;
    let {VIDEO, IMAGE, AUDIO, DYNAMIC_LOGO, OVERLAY, STATIC_IMAGE} = FJCoreConstant;
    let updateMedia = (subGraph, media) => {
      if (media) {
        let shouldRender = false;
        let status = media.getStatus();
        switch (type) {
          case VIDEO:
          case AUDIO:
          case IMAGE: {
            shouldRender = status !== subGraph.getMediaStatus();
            subGraph.setMediaStatus(media.getStatus());
            subGraph.setMediaDownloadingProgress(media.getProgress());
            if (type === VIDEO) {
              let rotation = media.rotation || 0;
              let size = media.size || {};
              subGraph.setVideoInfo({rotation, ...size});
            }

            if (type === VIDEO || type === AUDIO) {
              let duration = media.duration;
              if (duration && duration !== subGraph.originDuration) {
                subGraph.decode({originDuration: duration});
                subGraph.setEndTime(subGraph.getEndTime());
                decodeToTimeline();
                FJTimelineStore.effect();
                encodeFromTimeline(true);
                window.FJEvent.dispatch(FJEventConstant.UPDATE_TIMELINE);
              }
            }
            break;
          }
          case DYNAMIC_LOGO:
          case OVERLAY: {
            shouldRender = status !== subGraph.getMediaStatus();
            subGraph.setMediaStatus(media.getStatus());
            subGraph.setMediaDownloadingProgress(media.getProgress());
            break;
          }
          default:
        }

        if (shouldRender) {
          canvas.render(true);
        }
      }
    };
    let updateCache = (subGraph, cache) => {
      if (cache) {
        let cacheUrl = cache.getUrl();
        let func = (url) => {
          if (type === DYNAMIC_LOGO || type === OVERLAY) {
            subGraph.decode({url});
          } else {

            // 能设置url说明mediaStatus是success
            // TODO 在进行资源下载时由于状态的异步更新导致进入这里时mediaStatus可能是在下载中，所以内部渲染不会进行
            subGraph.setMediaStatus(FJMedia.MediaStatus().SUCCESS);
            subGraph.setUrl(url);
          }
          return canvas.reRender(true);
        };
        if (cacheUrl !== subGraph.getUrl()) {
          if (cacheUrl) {
            func(cacheUrl);
          } else {
            cache.initData()
              .then(() => {
                return func(cache.getUrl());
              }).catch(e => console.log(e));
          }
        }
      }
    };
    let dealGraph = (subGraph) => {
      let {sourceId} = subGraph;
      let media = FJMediaStore.getMediaById(sourceId);
      let cache = FJMediaCacheStore.getMediaCache(sourceId);
      updateMedia(subGraph, media);
      updateCache(subGraph, cache);
    };
    switch (type) {
      case VIDEO:
      case AUDIO:
      case IMAGE: {
        dealGraph(graph);
        break;
      }
      case DYNAMIC_LOGO:
      case OVERLAY: {
        graph.getGraphsByType(STATIC_IMAGE).forEach(image => {
          dealGraph(image);
        });
        break;
      }
      default:
    }
  }

  function decodeCanvas(data, ignoreColors, targetCanvas) {
    let {
      VIDEO,
      IMAGE,
      AUDIO,
      WIDGET,
      MULTI_WIDGET,
      SVG,
      DECORATION_OVERLAY,
      DYNAMIC_LOGO,
      WATERMARK_IMAGE,
      TEXT_ANIMATION,
    } = FJCoreConstant;
    let _canvas = targetCanvas || canvas;
    _canvas.decode(data);
    let {mainLayer} = _canvas.getAllLayer();
    _canvas.getAllGraphs().forEach((graph) => {
      initGraphEvent(graph);
      let type = graph.type;
      switch (type) {
        case VIDEO:
        case AUDIO:
        case IMAGE: {
          decodeMediaToGraph(graph);
          if (FJConfig.enableMainTrackEditMode && (type === VIDEO || type === IMAGE) && mainLayer.includes(graph.id)) {
            graph.setControlEnable(false);
          }
          break;
        }
        case WIDGET:
        case MULTI_WIDGET:
        case DECORATION_OVERLAY:
        case SVG:
          updateServerSource(type, graph.name, {ignoreColors, canvas: _canvas, fromType: graph.fromType});
          break;
        case DYNAMIC_LOGO:
          graph.forEachGraph(subGraph => {
            if (subGraph.type === FJCoreConstant.STATIC_IMAGE && subGraph.sourceId) {
              updateServerSource(type, subGraph.sourceId, {ignoreColors, canvas: _canvas});
            }
          });
          break;
        case TEXT_ANIMATION:
          graph.createAni();
          break;
        default:
      }
    });

    const watermark = _canvas.getWatermark();
    let watermarkImage = watermark.getChild(WATERMARK_IMAGE);
    if (watermarkImage && watermarkImage.sourceId) {
      updateServerSource(WATERMARK_IMAGE, watermarkImage.sourceId, {ignoreColors, canvas: _canvas});
    }
    _canvas.reRender(true).then(() => {
      _canvas.renderTrack()
    }).catch(e => console.log(e));
  }

  /**
   * @description 更新需要过滤渲染的数据
   * @param data
   * @param data.eventType
   * @param data.dragMode
   * @param data.graph
   */
  function updateIgnorGraphs({eventType, dragMode, graph}) {
    let ignoreIds = [];
    let id = graph.id;
    let layerType = canvas.getLayerType(canvas.layerOfGraphId(id));
    let {VIDEO, IMAGE, BACKGROUND} = FJCoreConstant;
    let {LAYER_MAIN} = FJAnimationCanvas.LayerType();

    let graphsInTime = (time) => {
      return canvas.getAllGraphs().filter(graph => {
        return canvas.isTimeInGraph(time, graph);
      })
    };
    let isMainResource = (type) => {
      return type === VIDEO || type === IMAGE || type === BACKGROUND;
    };
    let trimFilterFunc = (time) => {
      if (layerType === LAYER_MAIN) {
        graphsInTime(time).forEach((graph) => {
          if (graph.id !== id) {
            ignoreIds.push(graph.id);
          }
        });
      } else {
        if (isMainResource(graph.type)) {
          graphsInTime(time).forEach((graph) => {
            if (graph.id !== id && canvas.layerTypeOfGraphId(graph.id) !== LAYER_MAIN) {
              ignoreIds.push(graph.id);
            }
          });
        } else {
          canvas.forEachGraph((graph) => {
            if (canvas.layerTypeOfGraphId(graph.id) !== LAYER_MAIN && !isMainResource(graph.type)) {
              ignoreIds.push(graph.id);
            }
          });
        }
      }
    };
    let dragFilterFunc = () => {
      if (layerType === LAYER_MAIN) {
        ignoreIds.length = 0;
      } else {
        if (isMainResource(graph.type)) {
          canvas.forEachGraph((graph) => {
            if (canvas.layerTypeOfGraphId(graph.id) !== LAYER_MAIN) {
              ignoreIds.push(graph.id);
            }
          });
        } else {
          canvas.forEachGraph((graph) => {
            if (canvas.layerTypeOfGraphId(graph.id) !== LAYER_MAIN && !isMainResource(graph.type)) {
              ignoreIds.push(graph.id);
            }
          });
        }
      }
    };

    switch (dragMode) {
      case 1:
        trimFilterFunc(graph.getDelay());
        break;
      case 2:
        dragFilterFunc();
        break;
      case 3:
        trimFilterFunc(graph.getDelay() + graph.duration);
        break;
      default:
    }

    if (eventType === 'end') {
      canvas.clearIgnoreRender();
    } else {
      canvas.setIgnoreRender(ignoreIds);
    }
  }

  /**
   * @description 拖动时的预览
   * @param data
   * @param data.dragMode
   * @param data.graph
   */
  function previewForDrag({dragMode, graph}) {
    let id = graph.id;
    let layerType = canvas.getLayerType(canvas.layerOfGraphId(id));
    let {LAYER_MAIN} = FJAnimationCanvas.LayerType();
    let renderFunc = (time) => {
      canvas.clearAllTrack();
      canvas.seek(time).then(() => {
        canvas.render();
        canvas.clearAllTrack();
      }).catch(e => console.log(e));
    };
    switch (dragMode) {
      case 1:
        renderFunc(graph.getDelay())
        break;
      case 2: {
        let time = layerType === LAYER_MAIN ? _recordCurrentTime === -1 ? canvas.currentTime : _recordCurrentTime
          : graph.getDelay();
        renderFunc(time);
        break;
      }
      case 3:
        renderFunc(graph.getDelay() + graph.duration);
        break;
      default:
    }
  }

  /**
   * @description 结束裁切模式
   */
  function endCropMode() {
    if (!_isOperating && canvas.hasGraphInCropMode()) {
      let id = '';
      canvas.forEachGraph(graph => {
        if (graph.getCropMode()) {
          graph.setCropMode(false);
          id = graph.id;
        }
        if (graph.isGroup()) {
          graph.forEachGraph(subGraph => {
            if (subGraph.getCropMode()) {
              subGraph.setCropMode(false);
              id = subGraph.id;
            }
          });
        }
      });
      addUndo(id);
      saveOnline();
      canvas.render();
      window.FJEvent.dispatch('updateToolbar');
    }
  }

  function decodeToTimeline() {
    let {
      mainLayer,
      subLayer,
      subAudioLayer,
    } = canvas.getAllLayer();

    const createLayerData = (layer) => {
      return layer.map(id => {
        let graph = canvas.getGraphById(id);
        return wrapBrickData(graph);
      })
    };
    const createTransitionData = (transition) => {
      return transition.encode();
    };

    FJTimelineStore.decode({
      mainLayer: createLayerData(mainLayer),
      subLayer: createLayerData(subLayer),
      subAudioLayer: createLayerData(subAudioLayer),
    }, canvas.allTransitions().map(createTransitionData))
  }

  /**
   * @description 从时间线中获取数据并更新到canvas
   * @param flush
   * @return {string}
   */
  function encodeFromTimeline(flush) {
    let {
      TEXT_ANIMATION,
      SVG,
      VIDEO,
      IMAGE,
      OVERLAY,
      DYNAMIC_LOGO,
      WIDGET,
      MULTI_WIDGET,
      DECORATION_OVERLAY
    } = FJCoreConstant;
    let layer = FJTimelineStore.encode();
    let _layer = canvas.getAllLayer();
    let _preLayer = _.cloneDeep(_layer); // 用以检测某个元素的主副轴切换情况
    let _allGraphs = [...canvas.getAllGraphs()];
    let _cloneId = '';

    // 清空所有对象
    canvas.removeAll();
    let updateLayer = (timelineLayer, canvasLayer) => {

      // 清空当前层
      canvasLayer.length = 0;
      let cache = {};
      timelineLayer.forEach(brick => {
        let id = brick.cloneId || brick.id;
        let copyCacheGraph = FJTimelineStore.getCopyCache() && FJTimelineStore.getCopyCache().cache;
        let graph = cache[brick.id] || _allGraphs.find(graph => graph.id === id) || copyCacheGraph;
        if (graph) {
          if (brick.cloneId) {
            cache[brick.cloneId] = cache[brick.cloneId] || graph;
            graph = graph.clone();
            initGraphEvent(graph);
            _cloneId = graph.id;

            // 如果是克隆数据 则更新转场的真实 ID
            layer.transitions.forEach(transition => {
              if (transition.inKey === brick.id) {
                transition.inKey = _cloneId;
              }
              if (transition.outKey === brick.id) {
                transition.outKey = _cloneId
              }
            })
          }

          graph.decode({
            startTime: brick.startTime,
            endTime: brick.endTime,
            delay: brick.delay,
            speed: brick.speed,
          });

          let type = graph.type;

          // TODO
          // 此处需要做优化，避免多余的动画创建
          if (flush) {
            switch (type) {
              case TEXT_ANIMATION:
              case SVG:
              case OVERLAY:
              case DYNAMIC_LOGO:
                graph.createAni();
                break;
              case WIDGET:
              case MULTI_WIDGET:
              case DECORATION_OVERLAY:
                graph.updateSpeed();
                break;
              default:
            }
          }

          canvas.add(graph);
          canvasLayer.push(graph.id);
        }
      });
    };
    let isNewGraph = (graph) => {
      let hasFound = false;
      let id = graph.id;
      for (let key in _preLayer) {
        if (_preLayer.hasOwnProperty(key)) {
          hasFound = _preLayer[key].includes(id);
          if (hasFound) {
            break;
          }
        }
      }
      return !hasFound;
    };

    updateLayer(layer.mainLayer, _layer.mainLayer);
    updateLayer(layer.subLayer, _layer.subLayer);
    updateLayer(layer.subAudioLayer, _layer.subAudioLayer);

    _layer.mainLayer.forEach(id => {
      let graph = canvas.getGraphById(id);
      let {type} = graph;
      if (FJConfig.enableMainTrackEditMode && (type === VIDEO || type === IMAGE) && (_preLayer.subLayer.includes(id) || isNewGraph(graph))) {
        graph.setControlEnable(false);
      }
    });
    _layer.subLayer.forEach(id => {
      let graph = canvas.getGraphById(id);
      let {type} = graph;
      if (FJConfig.enableMainTrackEditMode && (type === VIDEO || type === IMAGE)) {
        if (isNewGraph(graph)) {
          graph.setControlEnable(false);
        } else if (_preLayer.mainLayer.includes(id)) {
          graph.setControlEnable(true);
        }
      }
    });

    canvas.allTransitions().length = 0;
    layer.transitions.forEach(transitionData => {
      canvas.addTransition(new FJTransition(transitionData));
    });

    let nextAllGraphs = canvas.getAllGraphs();
    _allGraphs.forEach(g => {

      // 是否是已经被删除的对象
      if (!nextAllGraphs.find(ng => ng.id === g.id)) g.clear();
    });

    return _cloneId;
  }

  function wrapBrickData(graph) {
    let media = FJMediaStore.getMediaById(graph.sourceId);
    return {
      id: graph.id,
      type: graph.type,
      sourceId: graph.sourceId,
      speed: graph.getSpeed(),
      delay: graph.getDelay(),
      startTime: graph.getStartTime(),
      endTime: graph.getEndTime(),
      originDuration: graph.originDuration,
      sourceStatus: media ? media.getStatus() : FJMedia.MediaStatus().SUCCESS,
      sourceName: media ? media.name : graph.sourceName,
      backgroundColor: graph.getBackgroundColor ? graph.getBackgroundColor() : '',
    }
  }

  /**
   * @description 更新需要请求的资源（没有出现在媒体库的资源）
   * @param type
   * @param sourceId
   * @param options
   * @param options.ignoreColors
   * @param options.fromType
   * @param options.canvas
   */
  function updateServerSource(type, sourceId, options) {
    let {
      WIDGET,
      MULTI_WIDGET,
      SVG,
      DECORATION_OVERLAY,
      DYNAMIC_LOGO,
      OVERLAY,
      STATIC_IMAGE,
      WATERMARK_IMAGE
    } = FJCoreConstant;
    let {ignoreColors, canvas: _canvas} = options || {};
    _canvas = _canvas || canvas;
    switch (type) {
      case SVG:
      case WIDGET:
      case MULTI_WIDGET: {
        FJElementStore.getElementData(type, sourceId, options).then((data) => {
          _canvas.forEachGraph(graph => {
            if (graph.name === sourceId) {
              if (graph.type === WIDGET || graph.type === MULTI_WIDGET) {
                let __data = {...data};
                if (ignoreColors) {
                  delete __data.colors;
                }
                graph.decode(__data);
              } else if (graph.type === SVG) {
                if (graph.fromType === FJViewConstant.SVG_WEB) {
                  graph.decode({svg: FJUtil.cloneNodeSync(data), svgString: FJSvgStore.svgToString(data)});
                } else {
                  graph.decode({svg: FJUtil.cloneNodeSync(data)});
                }
                graph.createAni();
              }
            }
          });
          _canvas.reRender(true);
        });
        break;
      }
      case DECORATION_OVERLAY:
        FJDecorationOverlayStore.getDecorationData(sourceId).then(data => {
          _canvas.forEachGraph(graph => {
            if (graph.type === DECORATION_OVERLAY && graph.name === sourceId) {
              let __data = {...data};
              if (ignoreColors) {
                delete __data.colors;
              }
              graph.decode({...__data});
            }
          });
          _canvas.reRender(true);
          window.FJEvent.dispatch('updateToolbar');
        });
        break;
      case WATERMARK_IMAGE:
      case OVERLAY:
      case DYNAMIC_LOGO: {
        let func = (cache) => {
          let url = cache.getUrl();
          let sourceId = cache.getId();
          const watermark = _canvas.getWatermark();

          // 给动态logo设置图片url
          _canvas.forEachGraph(graph => {
            if (graph.type === DYNAMIC_LOGO || graph.type === OVERLAY) {
              graph.forEachGraph(subGraph => {
                if (subGraph.type === STATIC_IMAGE && subGraph.sourceId === sourceId) {
                  subGraph.decode({url, mediaStatus: FJViewConstant.MEDIA_STATUS_SUCCESS});
                }
              });
            }
          });

          // 给图片水印设置url
          let imageWatermark = watermark.getChild(WATERMARK_IMAGE);
          if (imageWatermark && imageWatermark.sourceId === sourceId) {
            imageWatermark.decode({url, mediaStatus: FJViewConstant.MEDIA_STATUS_SUCCESS});
            window.FJEvent.dispatch(FJEventConstant.UPDATE_WATERMARK, url);
          }

          _canvas.reRender(true);
          window.FJEvent.dispatch('updateToolbar');
        };
        let cache = FJMediaCacheStore.getMediaCache(sourceId);
        if (cache) {
          if (!cache.getUrl()) {
            cache.initData().then(() => {
              func(cache);
            });
          } else {
            func(cache);
          }
        } else {
          const url = `${FJConfig.s3Path}${FJUtil.getUerId()}/${_canvas.getKey()}/resource/${sourceId}.png`;
          // const url = `./logo192.png`;
          FJMediaDownloadStore.downloadMedia(sourceId, url).catch(e => console.log(e));
        }
        break;
      }
      default:
    }
  }

  /**
   * @description 返回水平/垂直角度的合适值
   * @param angle
   * @return {number}
   */
  function nearestAngleLevel(angle) {
    if ((angle >= 0 && angle <= 45) || (angle >= 315 && angle <= 360)) {
      return 0;
    }

    if (angle >= 45 && angle <= 135) {
      return 90;
    }

    if (angle >= 135 && angle <= 225) {
      return 180;
    }

    if (angle >= 225 && angle <= 315) {
      return 270;
    }

    return 0;
  }

  /**
   * @description 返回指定方向下水平/垂直角度的合适值
   * @param angle
   * @param flag
   * @return {number}
   */
  function nearestAngleLevelWithDirection(angle, flag) {
    let range = [0, 90];
    if (angle === 0) {
      range = [270, 90];
    } else if (angle === 90) {
      range = [0, 180];
    } else if (angle === 180) {
      range = [90, 270];
    } else if (angle === 270) {
      range = [180, 0];
    } else if (angle > 0 && angle < 90) {
      range = [0, 90];
    } else if (angle > 90 && angle < 180) {
      range = [90, 180];
    } else if (angle > 180 && angle < 270) {
      range = [180, 270];
    } else if (angle > 270 && angle < 360) {
      range = [270, 0];
    }

    return range[flag === -1 ? 0 : 1];
  }

  /**
   * @description 对指定对象进行fit/fill
   * @param type
   * @param graph
   */
  function adaptiveGraph(type, graph) {
    let size = canvas.getSize();
    let angle = graph.getAngle();
    switch (type) {
      case FJCoreConstant.FILL: {
        graph.setAngle(nearestAngleLevel(angle));
        graph.fillRelativeRect(size);
        break;
      }
      case FJCoreConstant.FIT: {
        graph.setAngle(nearestAngleLevel(angle));
        graph.fitRelativeRect(size);
        break;
      }
      default:
    }
  }

  /**
   * @description 重置
   */
  function resetRecordTime() {
    _previewForDragDebounce.cancel();
    if (_recordCurrentTime !== -1) {
      canvas.setCurrentTime(_recordCurrentTime);
      _recordCurrentTime = -1;
    }
  }

  /** export
   * @description 加工用于分享的视频
   * @return {Blob}
   */
  function getVideoToShare() {
    let cache = FJExportStore.getCacheVideo();
    return new Blob([cache], {type: "video/mp4"});
  }

  /**
   * @description 获取入场graph
   * @return {T}
   */
  function getIntroGraph() {
    return exportPreviewCanvas.getAllGraphs().find(g => g.isIntro);
  }

  function hasExportPreviewCanvas() {
    return !!exportPreviewCanvas;
  }

  function activeCanvas() {
    return exportPreviewCanvas || canvas;
  }

  window.FJEvent.subscribe(FJEventConstant.GRAPH_INIT, canvas.renderTrack);

  canvas.on(FJConstant.MOUSE_DOWN, () => {
    window.FJEvent.dispatch('selection');
    window.FJEvent.dispatch(FJEventConstant.PAUSE);
    _isOperating = true;
    _keyCopeBeforeOperate = key.getScope();
    if (_keyCopeBeforeOperate) {
      FJUtil.toggleScope('start');
    }
  });
  canvas.on(FJConstant.MOUSE_UP, () => {
    _isOperating = false;
    if (_keyCopeBeforeOperate) {
      _keyCopeBeforeOperate = '';
      FJUtil.toggleScope('end');
    }
    window.FJEvent.dispatch(FJEventConstant.MOUSE_UP);
  });
  canvas.on(FJConstant.MOUSE_MOVE, (canvas, options) => {
    if (options) {
      let {event, controlType, controlGraph} = options;
      let pos = FJCoreUtil.calcCursorPoint(event);
      if (controlType === FJConstant.GRAPH_ROTATING) {
        let angle = controlGraph.getAngle();
        window.FJEvent.dispatch(FJEventConstant.GRAPH_ROTATE, {pos, angle});
      }
    }
  });

  // 初始化编码器
  let {transcoderPath, decoderPath} = FJConfig;
  FJEncoderManager.init(transcoderPath);
  FJDecoderManager.init(decoderPath, FJCanvasManager, FJVideoManager);

  return {

    /**
     * @description 异步执行操作，修改核心库
     */
    execute: async function () {
      try {
        let result = null;
        let key = arguments[0];
        let args = Array.prototype.slice.call(arguments, 1);

        switch (key) {
          case COMMANDS.UPDATE_CANVAS_SIZE: {
            let _canvas = activeCanvas();
            let _size = _canvas.getSize();
            let _nextSize = args[0];
            if (_size.width !== _nextSize.width || _size.height !== _nextSize.height) {
              _canvas.setSize(args[0]);

              // 避免异步渲染导致画面变化过大
              _canvas.clearCanvas(true);

              // logo需要重新加载
              await _canvas.reRender(true);
            }
            break;
          }
          case COMMANDS.CHANGE_PROJECT_NAME: {
            let name = args[0];
            let oldName = canvas.getName();
            let id = canvas.getKey();
            canvas.setName(name);
            if (hasExportPreviewCanvas()) {
              exportPreviewCanvas.setName(name);
            }
            try {
              await updateOnline(id, {name});
            } catch (e) {
              canvas.setName(oldName);
              if (hasExportPreviewCanvas()) {
                exportPreviewCanvas.setName(name);
              }
              throw new Error(e);
            }
            break;
          }
          case COMMANDS.SEEK: {
            let type = args[0];
            let progress = args[1];
            let isPercent = args[2];
            let flush = args[3];
            let useThrottle = args[4];
            let _canvas = activeCanvas();
            result = -1;
            switch (type) {
              case 'start':
                _isPlaying = _canvas.isPlaying();
                _canvas.pause();
                break;
              case 'change':

                // flush为假值时会吸附到元素
                if (!flush) {
                  let time = isPercent ? progress * _canvas.allDuration() : progress;
                  let newTime = -1;
                  let minOffset = Infinity;
                  _canvas.forEachGraph((graph) => {
                    let startInAll = graph.getDelay();
                    let endInAll = startInAll + graph.duration;
                    let adsorptionTime = FJTimelineStore.pixelToTime(ADSORPTION_VALUE);

                    if (Math.abs(time - startInAll) < adsorptionTime && Math.abs(time - startInAll) < minOffset) {
                      minOffset = Math.abs(time - startInAll);
                      newTime = startInAll;
                    }

                    if (Math.abs(time - endInAll) < adsorptionTime && Math.abs(time - endInAll) < minOffset) {
                      minOffset = Math.abs(time - endInAll);
                      newTime = endInAll;
                    }
                  });

                  if (newTime !== -1) {
                    progress = isPercent ? newTime / _canvas.allDuration() : newTime;
                    result = newTime;
                  }
                }

                if (isPercent) {
                  _canvas.setProgress(progress, useThrottle).then(() => {
                    _canvas.render();
                  });
                } else {
                  _canvas.seek(progress, useThrottle).then(() => {
                    _canvas.render();
                  });
                }
                break;
              case 'end':
                if (_isPlaying) {
                  _canvas.play(_playingCallback)
                }
                _canvas.reRender();
                break;
              default:
            }
            endCropMode();
            break;
          }
          case COMMANDS.RERENDER: {
            resetRecordTime();
            await canvas.reRender(true)
            break;
          }
          case COMMANDS.SAVE_FOR_LOCAL: {
            let json = canvas.encode();
            let zip = new JSZip();
            zip.file('project.json', JSON.stringify(json));
            let resource = zip.folder('resource');
            let {VIDEO, AUDIO, IMAGE} = FJCoreConstant;
            canvas.getAllGraphs().forEach(graph => {
              let graphType = graph.type;
              if (graphType === VIDEO || graphType === AUDIO || graphType === IMAGE) {
                let cache = FJMediaCacheStore.getMediaCache(graph.sourceId);
                let blob = cache && cache.getBlob();
                resource.file(blob.name, blob);
              }
            });

            await new Promise((resolve, reject) => {
              zip.generateAsync({type: "blob"})
                .then(function (content) {
                  FileSaver.saveAs(content, "record-cast.zip");
                  resolve();
                }).catch(reject);
            });
            break;
          }
          case COMMANDS.LOAD_FOR_LOCAL: {
            let data = args[0];
            let zip = new JSZip();
            try {
              let content = await zip.loadAsync(data);
              let keys = Object.keys(content.files);
              let json = null;
              for (let i = 0; i < keys.length; i++) {
                let fileName = keys[i];
                if (fileName === 'project.json') {
                  json = JSON.parse(await zip.file(fileName).async('string'));
                } else if (fileName !== 'resource/') {
                  let data = await zip.file(fileName).async('blob');
                  let type = '';
                  if (fileName.includes('jpg')) {
                    type = 'image/jpeg';
                  } else if (fileName.includes('png')) {
                    type = 'image/png';
                  } else {
                    type = 'application/octet-stream';
                  }
                  await FJMediaStore.addLocalMediaToLibrary(new File([data], name, {type}));
                }
              }

              if (json) {
                decodeCanvas(json, true);
              }
            } catch (e) {
              console.log(e);
            }
            break;
          }
          case COMMANDS.LOAD_FOR_ONLINE: {
            let projectData = args[0];
            let transVersionTwo = () => {
              projectData.graphs = JSON.parse(lzutf8.decompress(projectData.graphs, {inputEncoding: 'Base64'}));
              projectData.mediaLibrary = JSON.parse(lzutf8.decompress(projectData.mediaLibrary, {inputEncoding: 'Base64'}));
              projectData.transitions = JSON.parse(lzutf8.decompress(projectData.transitions, {inputEncoding: 'Base64'}));
            };
            let transVersionThree = () => {
              projectData.layer = JSON.parse(lzutf8.decompress(projectData.layer, {inputEncoding: 'Base64'}));
              projectData.watermark = JSON.parse(lzutf8.decompress(projectData.watermark, {inputEncoding: 'Base64'}));
            };
            if (projectData) {

              if (projectData.version === '2') {
                transVersionTwo();
              } else if (projectData.version === '3') {
                transVersionTwo();
                transVersionThree();
              }

              console.log(projectData);

              let mediaLoadedCallback = args[1];
              if(window.fjcloud && window.fjcloud.mediaList) {
                const cloudMediaList = window.fjcloud.mediaList;
                let cloudMediaIds = [];
                cloudMediaList.forEach(m => {
                  cloudMediaIds.push(m.key);
                });
                FJCloudStore.decode(cloudMediaIds);
              }
              let {
                VIDEO,
                IMAGE,
                AUDIO,
              } = FJCoreConstant;
              await loadProjectFont(projectData);
              projectData.graphs.forEach((graph) => {
                let type = graph.type;
                if (type === VIDEO || type === IMAGE || type === AUDIO) {
                  FJMediaStore.updateUsedMediaId(graph.sourceId);
                }
              });
              decodeCanvas(projectData, true);
              FJMediaStore.initMedias(canvas.getMediaLibrary(), (media, isChunk) => {
                if (media.getStatus() === FJMedia.MediaStatus().DOWNLOADING && isChunk) {
                  let {type, fromType} = media;
                  FJMediaDownloadStore.downloadMedia(media.id, '', {type, fromType}).catch((e) => {
                    console.log(e)
                  });
                }
                mediaLoadedCallback();
              });
            }
            break;
          }
          case COMMANDS.RE_SEEK_AND_RENDER: {
            await canvas.reRender(true);
            break;
          }
          case COMMANDS.RENDER_COVER:
            result = await renderCover();
            break;
          case COMMANDS.ENABLE_INTRO: {
            if (hasExportPreviewCanvas()) {
              let introName = args[0];
              let introData = args[1];
              let {videoName, videoEditor, viewSize} = args[2];
              let introGraph = null;
              decodeCanvas(canvas.encode(), true, exportPreviewCanvas);
              exportPreviewCanvas.getAllGraphs().forEach(graph => graph.removeFromView());
              exportPreviewCanvas.setSize(viewSize);
              introGraph = createGraph(FJCoreConstant.INTRO_WIDGET, {
                ...introData, id: introName,
                owner: exportPreviewCanvas,
              }, {
                name: introName,
                justCreate: true,
              });

              exportPreviewCanvas.forEachGraph(graph => {
                graph.setDelay(graph.getDelay() + introGraph.duration);
              });
              exportPreviewCanvas.add(introGraph);
              exportPreviewCanvas.addToLayer(exportPreviewCanvas.getAllLayer().mainLayer, introGraph.id, 0);

              introGraph.isIntro = true;
              introGraph.disableMedia();
              await introGraph.enableMedia();
              introGraph.updateTextData({videoName, videoEditor});

              exportPreviewCanvas.clearCanvas(true);
              exportPreviewCanvas.setMaxLimitTime(FJConfig.maxLimitTime + introGraph.duration);
            }
            break;
          }
          case COMMANDS.SHARE_TO_DROPBOX: {
            let name = canvas.getName();
            let editor = canvas.getEditor();
            result = await FJShareStore.uploadToDropbox(getVideoToShare(), name, editor)
            break;
          }
          case COMMANDS.SHARE_TO_YOUTUBE: {
            if (_youtubeCacheId) {
              result = _youtubeCacheId;
            } else {
              let onProgress = args[0];
              let name = canvas.getName() + ' ‑ Made with FlexClip.mp4';
              let event = await FJShareStore.shareVideoToYoutube(getVideoToShare(), name, onProgress);
              _youtubeCacheId = JSON.parse(event.target.response).id;
              result = _youtubeCacheId;
            }
            break;
          }
          default:
        }

        return result;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },

    /**
     * @description 同步执行操作，修改核心库
     */
    // eslint-disable-next-line complexity
    executeSync: function () {
      try {
        let result;
        let key = arguments[0];
        let args = Array.prototype.slice.call(arguments, 1);

        switch (key) {
          case COMMANDS.INIT_UNDO:
            FJUndoStore.init(canvas.encode());
            break;
          case COMMANDS.CLEAR_UNDO:
            clearUndo();
            break;
          case COMMANDS.DECODE_CANVAS: {
            decodeCanvas(args[0], true);
            break;
          }
          case COMMANDS.SAVE_FOR_ONLINE:
            saveOnline(_.isUndefined(args[0]) ? true : args[0]);
            break;
          case COMMANDS.SELECT_ITEM: {
            canvas.selectGraph(args[0])
            result = canvas.getSelectGraph();

            // 反选时可能会退出crop，所有这里需要渲染
            canvas.reRender();
            break;
          }
          case COMMANDS.GET_ALL_DURATION:
            result = canvas.allDuration();
            break;
          case COMMANDS.GET_EXPORT_PREVIEW_DURATION: {
            if (hasExportPreviewCanvas()) {
              let allDuration = exportPreviewCanvas.allDuration();
              if (args[0]) {
                return allDuration;
              } else {
                let maxLimitTime = exportPreviewCanvas.getMaxLimitTime();
                result = Math.min(allDuration, maxLimitTime);
              }
            }
            break;
          }
          case COMMANDS.GET_CURRENT_TIME:
            result = canvas.currentTime;
            break;
          case COMMANDS.GET_PROGRESS:
            result = canvas.getProgress();
            break;
          case COMMANDS.GET_ALL_TRACK_DATA:
            decodeToTimeline();
            result = FJTimelineStore.flush();
            break;
          case COMMANDS.DRAG_TIMELINE: {
            let id = args[0];
            let dragData = args[1];

            if (!id || !dragData) return;

            let {dragMode, eventType} = dragData;
            let graph = canvas.getGraphById(id);
            updateIgnorGraphs({eventType, dragMode, graph});
            try {
              decodeToTimeline();
              let {adsorptionLine, exchangeId, isCoverEle} = FJTimelineStore.dragTimeline(id, dragData);
              encodeFromTimeline(eventType === 'end');
              switch (eventType) {
                case 'start':
                  endCropMode();
                  _recordCurrentTime = canvas.currentTime;
                  result = [];
                  break;
                case 'change': {
                  canvas.clearAllTrack();
                  let _exchangeGraph = canvas.getGraphById(exchangeId);
                  if (_exchangeGraph) {
                    canvas.clearIgnoreRender();
                    canvas.setIgnoreRender([id]);
                    _exchangeGraph.render(canvas.contentView);
                    switch (_exchangeGraph.type) {
                      case FJCoreConstant.SVG:
                        _exchangeGraph.seek(0, true)
                        break;
                      default:
                        _exchangeGraph.goToCoverFrame && _exchangeGraph.goToCoverFrame();
                    }
                  }
                  _previewForDragDebounce({eventType, dragMode, graph});
                  result = {adsorptionLine: adsorptionLine, isCoverEle: isCoverEle};
                  break;
                }
                case 'end': {
                  resetRecordTime();
                  if (exchangeId) {
                    let _exchangeGraph = canvas.getGraphById(exchangeId);
                    let _layer = canvas.layerOfGraphId(_exchangeGraph.id);
                    let _index = canvas.indexGraphIdOfLayer(_exchangeGraph.id, _layer);
                    let autoPos = (elementSize, curRelativeRect) => {
                      let size = elementSize;
                      let viewSize = canvas.getSize();
                      let {x, y, width, height} = curRelativeRect;
                      let renderWidth = width * viewSize.width;
                      let renderHeight = renderWidth * size.height / size.width;
                      let _height = renderHeight / viewSize.height;
                      return {
                        x,
                        y: y - (_height - height) / 2,
                        width,
                        height: _height,
                      };
                    };
                    try {
                      switch (_exchangeGraph.type) {
                        case FJCoreConstant.TEXT_ANIMATION: {
                          graph.setRelativeRect(_exchangeGraph.getRelativeRect());

                          let __textData = _exchangeGraph.getTextData(true);
                          if (graph.textLength === 1 && __textData && __textData[0][0] === '') {
                            __textData[0] = _.cloneDeep(__textData[1]);
                            graph.setTextData(__textData);
                          } else {
                            graph.setTextData(__textData);
                          }

                          graph.setFontFamily(_exchangeGraph.getFontFamily());
                          graph.setBold(_exchangeGraph.getBold());
                          graph.setItalic(_exchangeGraph.getItalic());
                          graph.setMainColor(_exchangeGraph.getMainColor());
                          graph.setSubColor(_exchangeGraph.getSubColor());
                          graph.setAlignment(_exchangeGraph.getAlignment());
                          graph.setDelay(_exchangeGraph.getDelay());
                          graph.setStartTime(_exchangeGraph.getStartTime());
                          graph.setEndTime(_exchangeGraph.getEndTime());
                          graph.setAngle(_exchangeGraph.getAngle());
                          graph.createAni();

                          graph.setRelativeRect(autoPos(graph.getElementSize(), graph.getRelativeRect()));
                          break;
                        }
                        case FJCoreConstant.DYNAMIC_LOGO:
                        case FJCoreConstant.DECORATION_OVERLAY:
                        case FJCoreConstant.OVERLAY: {
                          graph.setDelay(_exchangeGraph.getDelay());
                          graph.setStartTime(_exchangeGraph.getStartTime());
                          graph.setEndTime(_exchangeGraph.getEndTime());

                          if (_exchangeGraph.type === FJCoreConstant.DYNAMIC_LOGO && graph.type === FJCoreConstant.DYNAMIC_LOGO) {
                            let _exchangeImages = _exchangeGraph.getGraphsByType(FJCoreConstant.STATIC_IMAGE);
                            let _curImages = graph.getGraphsByType(FJCoreConstant.STATIC_IMAGE);
                            _curImages.forEach((image, index) => {
                              let _eImage = _exchangeImages[index];
                              if (image && _eImage) {

                                let data = {
                                  cropType: _eImage.getCropType(),
                                  cropRelativeRect: _eImage.getCropRelativeRect(),
                                  sourceId: _eImage.sourceId,
                                  url: _eImage.getUrl(),
                                  mediaStatus: _eImage.getMediaStatus(),
                                };

                                try {
                                  if (data.cropRelativeRect.x === 0 && data.cropRelativeRect.y === 0
                                    && data.cropRelativeRect.width === 1 && data.cropRelativeRect.height === 1) {
                                    let curRect = FJCoreUtil.calcRenderRect(image.getRelativeRect(), canvas.getSize());
                                    let eRect = FJCoreUtil.calcRenderRect(_eImage.getRelativeRect(), canvas.getSize());
                                    let nextRect = {};
                                    let eRatio = eRect.width / eRect.height;
                                    if (eRatio > 1) {
                                      nextRect.height = curRect.height;
                                      nextRect.width = nextRect.height * eRatio;
                                    } else {
                                      nextRect.width = curRect.width;
                                      nextRect.height = nextRect.width / eRatio;
                                    }
                                    nextRect.x = curRect.x - (nextRect.width - curRect.width) / 2;
                                    nextRect.y = curRect.y - (nextRect.height - curRect.height) / 2;
                                    data.relativeRect = FJCoreUtil.calcRelativeRect(nextRect, canvas.getSize());
                                  }
                                } catch (e) {
                                  console.log(e);
                                  data.relativeRect = _eImage.getRelativeRect();
                                }

                                image.decode(data);
                              }
                            });
                          }

                          if (_exchangeGraph.type !== FJCoreConstant.DECORATION_OVERLAY && graph.type !== FJCoreConstant.DECORATION_OVERLAY) {
                            let __textData = graph.getTextData();
                            let __oldTextData = _exchangeGraph.getTextData();
                            let _textData = [];
                            __textData.forEach((textArr, index) => {
                              if (__oldTextData[index]) {
                                _textData.push(__oldTextData[index])
                              } else {
                                _textData.push(textArr)
                              }
                            })
                            graph.setTextData(_textData);
                          }

                          break;
                        }
                        case FJCoreConstant.SVG:
                        case FJCoreConstant.WIDGET: {
                          let elementSize = graph.defaultSize;
                          if (_exchangeGraph.type === FJCoreConstant.SVG
                            && ['solid-square', 'solid-circle', 'right-angle-triangle', 'regular-triangle'].includes(graph.name)) {
                            elementSize = FJCoreUtil.calcRenderRect(_exchangeGraph.getRelativeRect(), canvas.getSize())
                          }
                          graph.setRelativeRect(_exchangeGraph.getRelativeRect());
                          graph.setDelay(_exchangeGraph.getDelay());
                          graph.setOpacity(_exchangeGraph.getOpacity());
                          graph.setStartTime(_exchangeGraph.getStartTime());
                          graph.setEndTime(_exchangeGraph.getEndTime());
                          graph.setAngle(_exchangeGraph.getAngle());
                          graph.setFlip(_exchangeGraph.getFlip());
                          graph.setRelativeRect(autoPos(elementSize, graph.getRelativeRect()));
                          if (graph.type === FJCoreConstant.SVG && _exchangeGraph.type === FJCoreConstant.SVG) {
                            graph.setAnimationSlots(_exchangeGraph.getAnimationSlots());
                            graph.createAni();
                          }
                          break;
                        }
                      }
                    } catch (e) {
                      console.log(e);
                    }

                    canvas.remove(_exchangeGraph);
                    canvas.removeFromLayer(_exchangeGraph.id);
                    canvas.removeFromLayer(graph.id);
                    canvas.addToLayer(_layer, graph.id, _index);
                    graph.disableMedia();
                    canvas.reRender();

                  }
                  result = {adsorptionLine: [], isCoverEle: false};
                  addUndo(graph.id);
                  saveOnline();
                  canvas.renderTrack();
                  break;
                }
              }
            } catch (e) {
              console.log(e);
            }
            break;
          }
          case COMMANDS.ADD_TIMELINE:
          case COMMANDS.ADD_SUBLAYER_TIMELINE: { // 添加资源到副轴
            let data = args[0];
            let {type, fromType, value} = data;
            let {WIDGET, MULTI_WIDGET, SVG, DECORATION_OVERLAY} = FJCoreConstant;
            result = newTimeline(data, key === COMMANDS.ADD_TIMELINE);
            switch (type) {
              case DECORATION_OVERLAY:
              case WIDGET:
              case MULTI_WIDGET:
              case SVG:
                updateServerSource(type, value, {fromType});
                break;
              default:
            }
            break;
          }
          case COMMANDS.APP_CONTENT_MOUSE_DOWN: {
            let cursorPoint = args[0];
            let {left, top, width, height} = canvas.lowerCanvas.getBoundingClientRect();
            if (!FJCoreUtil.isPointInRect(cursorPoint, {x: left, y: top, width, height})) {
              endCropMode();
            }
            break;
          }
          case COMMANDS.INIT_CANVAS: {
            canvas.bindCanvas(args[0]);
            canvas.bindEventView(args[1]);
            FJCoreUtil.addEvent(document.body, 'keydown', endCropMode);
            break;
          }
          case COMMANDS.IS_PLAYING:
            result = activeCanvas().isPlaying();
            break;
          case COMMANDS.PLAY: {
            let _canvas = activeCanvas();
            if (!_canvas.isPlaying()) {

              // let tip = $("#timeline-container").children().eq(0).find("p");
              // let p1 = $(".FJSlider_slider__3yxou > .FJSlider_handle__2MMw5").eq(0);
              // let p2 = $(".FJMultiProcess_handle_container__1Mkqu");
              // let p2W = $(".FJTimelineBox_container__1h6C5").width();
              //
              // _playingCallback = () => {
              //   let currentTime = _canvas.currentTime;
              //
              //   tip.html("00:00:"+Math.round(currentTime)+" / 00:01:13");
              //
              //   let progress = currentTime/73;
              //   p1.css({
              //     left: (progress*100)+"%"
              //   });
              //
              //   progress = p2W*progress;
              //   p2.css({
              //     transform: "translateX("+progress+"px)"
              //   })
              // };
              _playingCallback = args[0];
              _canvas.play(_playingCallback);
            }
            break;
          }
          case COMMANDS.PAUSE: {
            let _canvas = activeCanvas();
            if (_canvas.isPlaying()) {
              _canvas.pause();
              _canvas.renderTrack();
            }
            break;
          }
          case COMMANDS.RENDER_THUMBNAIL: {
            let id = args[0];
            let domCanvas = args[1];
            let graph = canvas.getGraphById(id);
            if (!graph)
              return;
            let mediaCache = FJMediaCacheStore.getMediaCache(graph.sourceId);
            if (mediaCache && mediaCache.getData()) {
              let media = FJMediaStore.getMediaById(graph.sourceId);
              if (media && media.size) {
                result = FJUtil.renderVideoThumbnail(domCanvas, mediaCache.getUrl(), {
                  start: graph.getStartTime(),
                  end: graph.getEndTime(),
                }, {
                  ...media.size,
                  rotation: media.rotation,
                });
              }
            }
            break;
          }
          case COMMANDS.GET_GRAPHS_BY_SOURCE_ID: { // 返回时间轴中是否使用了含有SourceId的对象
            let sourceId = args[0];
            result = canvas.getAllGraphs().filter(graph => graph.sourceId === sourceId);
            break;
          }
          case COMMANDS.DELETE_GRAPHS_BY_SOURCE_IDS: { // 删除时间轴中含有SourceId的对象
            let sourceIds = args[0];
            let selectedId = args[1];
            let callback = args[2];
            let ids = [];
            sourceIds.forEach(sourceId => {
              canvas.getAllGraphs().filter(graph => graph.sourceId === sourceId).forEach(graph => {
                ids.push(graph.id);
              });
            });
            decodeToTimeline();
            ids.forEach(id => FJTimelineStore.deleteTimeline(id));
            encodeFromTimeline(true);
            if ((selectedId && ids.indexOf(selectedId) !== -1) || !canvas.getSelectGraph()) {
              callback();
            }
            canvas.render();
            saveOnline();
            break;
          }
          case COMMANDS.DELETE_GRAPHS_BY_ID: { // 根据id 删除时间轴中的对象
            let id = args[0];
            let isInvalidUndo = args[1];
            if (id === -1) {
              return
            }
            decodeToTimeline();
            FJTimelineStore.deleteTimeline(id);
            encodeFromTimeline(true);

            if (!isInvalidUndo) {
              addUndo(id);
              saveOnline();
            }

            canvas.reRender(true);
            break;
          }
          case COMMANDS.SET_GRAPH_DELAY_BY_ID: { // 根据id 设置delay
            let id = args[0];
            let delay = args[1];
            canvas.getGraphById(id).setDelay(delay);
            break;
          }
          case COMMANDS.EXPORT: {
            let {size, fps, type, exportCallback} = args[0];
            let _canvas = activeCanvas();
            _canvas.updateGraphsMute();
            let _name = _canvas.getName();
            switch (type) {
              case 'MP4':
                _name = `${_name} ‑ Made with FlexClip.mp4`;
                break;
              case 'GIF':
                _name = `${_name} ‑ Made with FlexClip.gif`;
                break;
              default:
            }
            _canvas.pause();
            FJExportStore.export({
              type,
              encoder: FJEncoderManager,
              decoder: FJDecoderManager,
              maxLimitTime: _canvas.getMaxLimitTime(),
              fps: fps || FJConfig.fps,
              mediaManager: FJMediaCacheStore,
              hasAudio: type === 'MP4' && hasAudioForExport(),
              downloadName: _name,
              canvas: _canvas,
              size: FJUtil.calcSizeWithRatioType(size, _canvas.getRatioType()),
              exportCallback,
            });
            break;
          }
          case COMMANDS.EXPORT_CANCEL: {
            FJExportStore.cancel();
            break;
          }
          case COMMANDS.DOWNLOAD_EXPORT_VIDEO: // 下载输出视频
            FJExportStore.downloadCacheVideo();
            break;
          case COMMANDS.CLEAR_CACHE_VIDEO: // 清除输出视频
            FJExportStore.clearCacheVideo();
            _youtubeCacheId = '';
            break;
          case COMMANDS.GET_GRAPHS_BY_ID: { // 根据id找graph
            let id = args[0];
            result = canvas.getGraphById(id);
            break;
          }
          case COMMANDS.SUBSCRIBE_SELECTION: {
            let func = args[0];
            window.FJEvent.subscribe('selection', () => {
              func(allSelectedId());
            });
            break;
          }
          case COMMANDS.SUBSCRIBE_PAUSE: {
            let func = args[0];
            window.FJEvent.subscribe('pause', () => {
              func();
            });
            break;
          }
          case COMMANDS.GET_TIMELINE_IS_ELE: {
            result = false;

            let mainLayerGraphs = canvas.getGraphsInLayer(canvas.getAllLayer().mainLayer);
            for (let i = 0; i < mainLayerGraphs.length; i++) {
              if (canvas.isTimeInGraph(canvas.currentTime, mainLayerGraphs[i])) {
                result = true;
              }
            }

            if (!result) {
              let selectedGraph = canvas.getSelectGraph();
              result = selectedGraph && canvas.isTimeInGraph(canvas.currentTime, selectedGraph);
            }

            break;
          }
          case COMMANDS.SPLIT_TIMELINE: {
            let selectedGraph = canvas.getGraphById(args[0]);

            // 如果没有选中的对象则分割主轴元素
            if (!selectedGraph || !canvas.isTimeInGraph(canvas.currentTime, selectedGraph)) {
              let mainLayerGraphs = canvas.getGraphsInLayer(canvas.getAllLayer().mainLayer);
              for (let i = 0; i < mainLayerGraphs.length; i++) {
                if (canvas.isTimeInGraph(canvas.currentTime, mainLayerGraphs[i])) {
                  selectedGraph = mainLayerGraphs[i];
                  break;
                }
              }
            }

            if (selectedGraph) {
              let delay = selectedGraph.getDelay();
              let ratio = (canvas.currentTime - delay) / selectedGraph.duration;
              decodeToTimeline();
              result = FJTimelineStore.splitTimeline(selectedGraph.id, ratio);
              encodeFromTimeline(true);
              if (result) {
                saveOnline();
                addUndo(selectedGraph.id);
                canvas.reRender();
              } else {
                FJMessageStore.addMessage(FJLocalStore._('split-error-tip'), 'error');
              }
            }
            canvas.renderTrack();
            break;
          }
          case COMMANDS.SET_MEDIA_LIBRARY: {
            canvas.setMediaLibrary(args[0].map(media => {
              return {
                id: media.id,
                type: media.type,
                fromType: media.fromType,
                duration: media.duration,
                name: media.name,
              }
            }));
            saveOnline();
            break;
          }
          case COMMANDS.SET_WIDGET_DATA: {
            let colors = args[0];
            let options = args[1];
            let graph = canvas.getSelectGraph();
            if (graph) {
              if (!_.isUndefined(colors)) {
                graph.setColors(colors);
              }

              if (!options || !options.type || (options && options.type === 'changeEnd')) {
                addUndo(graph.id);
                saveOnline();
              }
            }
            break;
          }
          case COMMANDS.SET_SVG_DATA: {
            let data = args[0];
            let options = args[1];
            let graph = canvas.getSelectGraph();
            if (graph) {
              if (!_.isUndefined(data.colors)) {
                graph.setColors(data.colors);
              }
              if (!_.isUndefined(data.introName)) {
                graph.setAnimationSlot({
                  name: FJIntroOutroStore.viewNameToCoreName(data.introName),
                  id: FJViewConstant.INTRO,
                  start: 0,
                  end: 1,
                });
              }
              if (!_.isUndefined(data.outroName)) {
                graph.setAnimationSlot({
                  name: FJIntroOutroStore.viewNameToCoreName(data.outroName),
                  id: FJViewConstant.OUTRO,
                  start: graph.duration - 1,
                  end: graph.duration,
                });
              }

              if (!options || !options.type || (options && options.type === 'changeEnd')) {
                addUndo(graph.id);
                saveOnline();
              }
            }
            break;
          }
          case COMMANDS.SET_TEXT_ANIMATION_DATA: {
            let data = args[0];
            let options = args[1];
            let graph = canvas.getSelectGraph();
            if (graph) {
              if (!_.isUndefined(data.zoomIn)) {
                graph.zoomIn();
              }
              if (!_.isUndefined(data.zoomOut)) {
                graph.zoomOut();
              }
              if (!_.isUndefined(data.fontFamily)) {
                graph.setFontFamily(data.fontFamily);
                graph.updatePositionToOriginCenter();

              }
              if (!_.isUndefined(data.textData)) {
                graph.setTextData(_.cloneDeep(data.textData));
                graph.updatePositionToOriginCenter();
              }
              if (!_.isUndefined(data.bold)) {
                graph.setBold(data.bold);
                graph.updatePositionToOriginCenter();
              }
              if (!_.isUndefined(data.italic)) {
                graph.setItalic(data.italic);
                graph.updatePositionToOriginCenter();
              }
              if (!_.isUndefined(data.mainColor)) {
                graph.setMainColor(data.mainColor);
              }
              if (!_.isUndefined(data.subColor)) {
                graph.setSubColor(data.subColor);
              }
              if (!_.isUndefined(data.alignment)) {
                graph.setAlignment(data.alignment);
                if (graph.isPlaying()) {
                  graph.play();
                }
              }
              if (!_.isUndefined(data.position)) {
                let alignment;
                switch (data.position) {
                  case FJCoreConstant.LEFT_TOP:
                  case FJCoreConstant.LEFT:
                  case FJCoreConstant.LEFT_BOTTOM:
                    alignment = 'left';
                    break;
                  case FJCoreConstant.TOP:
                  case FJCoreConstant.CENTER:
                  case FJCoreConstant.BOTTOM:
                    alignment = 'center';
                    break;
                  case FJCoreConstant.RIGHT_TOP:
                  case FJCoreConstant.RIGHT:
                  case FJCoreConstant.RIGHT_BOTTOM:
                    alignment = 'right';
                    break;
                }

                graph.setPosition(data.position);
                graph.setAlignment(alignment);
                if (graph.isPlaying()) {
                  graph.play();
                }
              }

              canvas.render();
              if (!options || !options.type || (options && options.type === 'changeEnd')) {
                addUndo(graph.id);
                saveOnline();
              }
            }
            break;
          }
          case COMMANDS.SET_VIDEO_ATTRIBUTES_DATA: {
            let data = args[0];
            let options = args[1];
            let graph = canvas.getSelectGraph();
            let success = true;
            if (graph) {

              if (!_.isUndefined(data.volume)) {
                graph.setVolume(FJCoreUtil.toFixed(data.volume, 2));
              }
              if (!_.isUndefined(data.scale)) {
                setRelativeRectByScale(graph, FJCoreUtil.toFixed(data.scale / 100, 2));
              }
              if (!_.isUndefined(data.adaptive)) {
                adaptiveGraph(data.adaptive, graph);
              }
              if (!_.isUndefined(data.speed)) {

                let pureDuration = graph.pureDuration;
                if (!pureDuration || pureDuration / data.speed < FJConfig.minLimitTime) {
                  success = false;
                } else {
                  // 设置速度可能会影响时间线的布局处理
                  decodeToTimeline();
                  FJTimelineStore.setSpeed(graph.id, data.speed);
                  encodeFromTimeline();

                  FJUtil.ealog('timeline_speed_use', true);
                }
              }

              if (success) {
                canvas.render();
                if (!options || !options.type || (options && options.type === 'slideStop')) {
                  addUndo(graph.id);
                  saveOnline();
                }
              }
              result = success;
            }
            break;
          }
          case COMMANDS.SET_MEDIA_OPACITY_DATA: {
            let type = args[0];
            let value = args[1];
            let graph = canvas.getSelectGraph();
            if (graph) {
              graph.setOpacity(FJCoreUtil.toFixed(value / 100, 2));
              if (type === 'slideStop') {
                addUndo(graph.id);
                saveOnline();

                FJUtil.ealog('timeline_opacity_use', true);
              }

              canvas.render();
            }
            break;
          }
          case COMMANDS.SET_AUDIO_ATTRIBUTES_DATA: {
            let data = args[0];
            let options = args[1];
            let graph = canvas.getSelectGraph();
            if (graph) {
              if (!_.isUndefined(data.volume)) {
                graph.setVolume(FJCoreUtil.toFixed(data.volume, 2));
              }
              if (!_.isUndefined(data.fadeIn)) {
                graph.setFadeInTime(FJCoreUtil.toFixed(data.fadeIn, 1))
              }
              if (!_.isUndefined(data.fadeOut)) {
                graph.setFadeOutTime(FJCoreUtil.toFixed(data.fadeOut, 1))
              }
              if (!options || !options.type || (options && options.type === 'slideStop')) {
                addUndo(graph.id);
                saveOnline();
              }
            }
            break;
          }
          case COMMANDS.SET_PHOTO_ATTRIBUTES_DATA: {
            let data = args[0];
            let options = args[1];
            let graph = canvas.getSelectGraph();
            if (graph) {

              if (!_.isUndefined(data.scale)) {
                setRelativeRectByScale(graph, FJCoreUtil.toFixed(data.scale / 100, 2));
              }
              if (!_.isUndefined(data.adaptive)) {
                adaptiveGraph(data.adaptive, graph);
              }
              if (!_.isUndefined(data.animationType)) {
                graph.setAnimationType(data.animationType);
                FJUtil.ealog('timeline_tool_photoanimation_click')
              }

              canvas.render();
              if (!options || !options.type || (options && options.type === 'slideStop')) {
                addUndo(graph.id);
                saveOnline();
              }
            }
            break;
          }
          case COMMANDS.SET_OVERLAY_DATA: {
            let data = args[0];
            let options = args[1];
            let graph = canvas.getSelectGraph();
            let subGraph = graph && canvas.getSelectGraph.call(graph);
            let shapeTypeFunc = () => {
              if (!_.isUndefined(data.color) && !_.isUndefined(data.index)) {
                let _colors = [...graph.getAllColors()];
                _colors[data.index] = data.color;
                graph.setAllColors(_colors);
              }
              if (!_.isUndefined(data.position)) {
                graph.setPosition(data.position);
                canvas.reRender();
              }
              if (!_.isUndefined(data.textData)) {
                graph.setTextData(data.textData);
              }

              if (!options || !options.type || (options && options.type === 'changeEnd')) {
                addUndo(graph.id);
                saveOnline();
                canvas.render();
              }
            };
            if (subGraph) {
              let {SHAPE, TEXT, STATIC_IMAGE} = FJCoreConstant;
              let {type} = subGraph;
              let __selectedGraph = canvas.getSelectGraph(true);
              let __undoId = __selectedGraph && __selectedGraph.id;
              switch (type) {
                case SHAPE:
                  shapeTypeFunc();
                  break;
                case TEXT:
                  if (!_.isUndefined(data.position)) {
                    graph.setPosition(data.position);
                    canvas.reRender();
                  }
                  if (!_.isUndefined(data.color)) {
                    subGraph.setColor(data.color);
                  }
                  if (!_.isUndefined(data.fontFamily)) {
                    subGraph.setFontFamily(data.fontFamily);
                    graph.renderCache();
                  }
                  if (!_.isUndefined(data.bold)) {
                    subGraph.setBold(data.bold);
                    graph.renderCache();
                  }
                  if (!_.isUndefined(data.italic)) {
                    subGraph.setItalic(data.italic);
                    graph.renderCache();
                  }
                  if (!_.isUndefined(data.textData)) {
                    graph.setTextData(data.textData);
                    graph.renderCache();
                  }
                  if (!options || !options.type || (options && options.type === 'changeEnd')) {
                    addUndo(__undoId);
                    saveOnline();
                    canvas.render();
                  }
                  break;
                case STATIC_IMAGE:
                  if (!_.isUndefined(data.position)) {
                    graph.setPosition(data.position);
                    canvas.render();
                    addUndo(__undoId);
                    saveOnline();
                  }
                  if (!_.isUndefined(data.rotate)) {
                    let value = data.rotate === 1 ? 90 : -90
                    subGraph.setAngle(subGraph.getAngle() + value);
                    canvas.render();
                    addUndo(__undoId);
                    saveOnline();
                  }
                  if (!_.isUndefined(data.mediaData)) {
                    let {sourceId, url} = data.mediaData;
                    let decodeData = {sourceId, url, angle: 0};
                    let hasSourceId = !!subGraph.sourceId;
                    let preSize = FJCoreUtil.calcRenderRect(subGraph.getRelativeRect(), canvas.getSize());
                    let cropRelativeRect = subGraph.getCropRelativeRect();
                    let shouldAutoStep = hasSourceId && preSize.width !== preSize.height
                      && cropRelativeRect && cropRelativeRect.x === 0
                      && cropRelativeRect.y === 0 && cropRelativeRect.width === 1
                      && cropRelativeRect.height === 1;
                    subGraph.decode(decodeData);
                    subGraph.setUrl(url, !shouldAutoStep, shouldAutoStep).then(() => {
                      canvas.render();
                      addUndo(__undoId);
                      saveOnline();
                    });
                  }
                  break;
                default:
              }
            } else if (graph) {
              shapeTypeFunc();
            }
            break;
          }
          case COMMANDS.SET_WATERMARK_DATA: {
            let data = args[0];
            let options = args[1];
            let watermark = canvas.getWatermark();
            let curWatermark = watermark.getChild();
            let type = curWatermark && curWatermark.type;
            let {WATERMARK_TEXT} = FJCoreConstant;

            if (!_.isUndefined(data.activeType)) {
              watermark.setActiveType(data.activeType);
            }

            if (!_.isUndefined(data.fontFamily)) {
              curWatermark.setFontFamily(data.fontFamily);
              if (type === WATERMARK_TEXT) {
                curWatermark.renderCache();
              }
            }

            if (!_.isUndefined(data.fontColor)) {
              curWatermark.setColor(data.fontColor);
              if (type === WATERMARK_TEXT) {
                curWatermark.renderCache();
              }
            }

            if (!_.isUndefined(data.text)) {
              let curText = curWatermark.getTextData().join();
              let nextText = data.text.split('\n');
              curWatermark.setTextData(nextText);
              if (curText === '' && nextText !== '') {
                FJUtil.ealog('timeline_watermark_type_use', true);
              }
              if (type === WATERMARK_TEXT) {
                curWatermark.renderCache();
              }
            }

            if (!_.isUndefined(data.opacity)) {
              curWatermark.setOpacity(data.opacity);
              if (type === WATERMARK_TEXT) {
                curWatermark.renderCache();
              }
            }

            if (!_.isUndefined(data.size)) {
              curWatermark.setSize(data.size);
            }

            if (!_.isUndefined(data.position)) {
              curWatermark.setPosition(data.position);
            }

            if (!_.isUndefined(data.mediaData)) {
              let {url} = data.mediaData;
              if (url) {
                watermark.addWatermarkImage({
                  ...data.mediaData,
                  ...curWatermark ? {
                    opacity: curWatermark.getOpacity(),
                    size: curWatermark.getSize(),
                    position: curWatermark.getPosition(),
                  } : null
                });
              } else {
                watermark.removeWatermarkImage();
              }
              FJUtil.ealog('timeline_watermark_type_use', true);
            }

            if (!options || !options.type || (options && (options.type === 'changeEnd' || options.type === 'slideStop'))) {
              addUndo();
              saveOnline();
            }

            canvas.reRender(true);
            break;
          }
          case COMMANDS.SUBSCRIBE_DOUBLE_CLICK_IN_TRACK: {
            let func = args[0];
            window.FJEvent.subscribe('doubleClickInTrack', (index) => {
              endCropMode();
              let graph = canvas.getSelectGraph(true);
              func(graph && graph.type, index);
            });
            break;
          }
          case COMMANDS.GET_WATERMARK:
            result = canvas.getWatermark();
            break;
          case COMMANDS.GET_SELECTED_AND_IS_RENDER_GRAPH: {
            let graph = canvas.getSelectGraph();
            if (graph && canvas.isTimeInGraph(canvas.currentTime, graph)) {
              let subGraph = graph.isGroup() && canvas.getSelectGraph.call(graph);
              result = {graph, subGraph};
            }
            break;
          }
          case COMMANDS.GET_SELECTED_AND_COULD_OPERATE_EDIT: {
            let graph = canvas.getSelectGraph();
            let {mainLayer} = canvas.getAllLayer();
            if (graph && canvas.isTimeInGraph(canvas.currentTime, graph)) {
              result = true;
              if (!mainLayer.find(item => item === graph.id)) {
                result = false;
              }
            }
            break;
          }
          case COMMANDS.SET_PROJECT_ID:
            canvas.setKey(args[0]);
            break;
          case COMMANDS.UPDATE_GRAPH_URL: {
            let {SUCCESS, LINK} = FJMedia.MediaStatus();
            let {LOCAL} = FJMedia.MediaFromType();
            FJMediaStore.getMedias().forEach((media) => {
              let mediaCache = media.getMediaCache();
              let sourceId = media.id;
              let fromType = media.fromType;
              let graphs = canvas.getAllGraphsBySourceId(sourceId);
              let url = mediaCache && mediaCache.getUrl();
              if (url) {
                graphs.forEach(graph => {
                  graph.setUrl(url);
                  graph.setMediaStatus(SUCCESS);
                  if (graph.type === FJCoreConstant.VIDEO) {
                    let rotation = media.rotation;
                    let size = media.rotation;
                    graph.setVideoInfo({rotation, ...size});
                  }
                });
              } else {
                graphs.forEach(graph => {
                  if (fromType === LOCAL && !FJCloudStore.isCloudMedia(sourceId)) {
                    graph.setMediaStatus(LINK);
                  }
                });
              }
            })
            break;
          }
          case COMMANDS.UPDATE_GRAPH_MEDIA_STATUS: {
            FJMediaStore.getMedias().forEach((media) => {
              let sourceId = media.id;
              let graphs = canvas.getAllGraphsBySourceId(sourceId);
              let status = media.getStatus();
              let progress = media.getProgress();

              graphs.forEach(graph => {
                if (graph.type === FJCoreConstant.VIDEO
                  || graph.type === FJCoreConstant.AUDIO
                  || graph.type === FJCoreConstant.IMAGE) {
                  graph.setMediaStatus && graph.setMediaStatus(status);
                  graph.setMediaDownloadingProgress(progress);
                }
              });
            })
            break;
          }
          case COMMANDS.GET_VIDEO_EDITOR:
            result = canvas.getEditor();
            break;
          case COMMANDS.GET_PROJECT_NAME:
            result = canvas.getName();
            break;
          case COMMANDS.GET_PROJECT_ID:
            result = canvas.getKey();
            break;
          case COMMANDS.GET_SELECTED_GRAPH_CENTER_TIME: {
            let graph = canvas.getSelectGraph();
            if (!graph) {
              result = canvas.currentTime;
            } else {
              let __location = args[0];
              result = graph.getDelay() + graph.duration * __location;
            }
            break;
          }
          case COMMANDS.CLEAR_LOGIN_TO_SAVE_TIMER: {
            clearLoginToSaveTimer();
            break;
          }
          case COMMANDS.GET_ALL_GRAPHS: { // 返回时间轴中所有graphs
            result = canvas.getAllGraphs();
            break;
          }
          case COMMANDS.SET_BACKGROUND_COLOR_ATTRIBUTES_DATA: {
            let data = args[0];
            let options = args[1];
            let graph = canvas.getSelectGraph();

            if (graph) {
              if (!_.isUndefined(data.backgroundColor)) {
                graph.setBackgroundColor(data.backgroundColor);
              }
            }

            canvas.render();
            if (!options || !options.type || (options && options.type === 'changeEnd')) {
              addUndo(graph.id);
              saveOnline();
            }
            break;
          }
          case COMMANDS.SET_GRAPH_CROP_MODE: {
            let id = args[0];
            let toggle = !!args[1];
            let shouldRecordCropData = args[2];
            let graph = canvas.getGraphById(id);
            if (graph) {
              let _graph = graph.isGroup() ? canvas.getSelectGraph.call(graph) : graph;
              if (_graph) {
                _graph.setCropMode(toggle);
                if (toggle) {
                  _recordCropData = {
                    relativeRect: {..._graph.getRelativeRect()},
                    cropRelativeRect: {..._graph.getCropRelativeRect()},
                    cropType: _graph.getCropType(),
                  }
                } else {
                  if (shouldRecordCropData && _recordCropData) {
                    _graph.setCropType(_recordCropData.cropType);
                    _graph.setRelativeRect(_recordCropData.relativeRect);
                    _graph.setCropRelativeRect(_recordCropData.cropRelativeRect);
                  }
                }
                FJUtil.ealog('timeline_tool_crop_click')
                canvas.render(true);
              }
            }
            break;
          }
          case COMMANDS.SET_GRAPH_CROP_TYPE: {
            let id = args[0];
            let type = args[1];
            let graph = canvas.getGraphById(id);
            if (graph) {
              let maskType = '';
              let {CROP_TYPE_SQUARE, CROP_TYPE_CIRCLE} = FJConstant;
              switch (type) {
                case 1:
                  maskType = CROP_TYPE_SQUARE;
                  break;
                case 2:
                  maskType = CROP_TYPE_CIRCLE;
                  break;
                default:
              }
              let _graph = graph.isGroup() ? canvas.getSelectGraph.call(graph) : graph;
              if (_graph) {
                if (maskType) {
                  _graph.setCropType(maskType);
                } else {
                  _graph.resetCrop(canvas.getSize());
                }
                canvas.render();
                FJUtil.ealog('timeline_tool_mask_click')
              }
            }
            break;
          }
          case COMMANDS.CLEAR_COPY_CACHE:
            FJTimelineStore.clearCopyCache();
            break;
          case COMMANDS.COPY: {
            let selectedGraph = canvas.getSelectGraph();
            if (selectedGraph) {
              endCropMode();
              let layer = canvas.layerOfGraphId(selectedGraph.id);
              if (selectedGraph && layer) {
                decodeToTimeline();
                let cloneGraph = selectedGraph.clone();
                FJTimelineStore.copyTimeline(cloneGraph, wrapBrickData(cloneGraph), canvas.getLayerType(layer));
                result = true;
              } else {
                result = false;
              }
            }
            break;
          }
          case COMMANDS.PASTE: {
            decodeToTimeline();
            FJTimelineStore.pasteTimeline(canvas.currentTime);
            result = encodeFromTimeline(true);
            if (result) {
              addUndo(result);
              saveOnline();
            }
            break;
          }
          case COMMANDS.GET_COPY_STATUS: {
            result = !!canvas.getSelectGraph();
            break;
          }
          case COMMANDS.GET_PASTE_STATUS:
            if (FJTimelineStore.hasCopyCache()) {
              let {layerType} = FJTimelineStore.getCopyCache();
              let {LAYER_SUB, LAYER_SUB_AUDIO, LAYER_MAIN} = FJAnimationCanvas.LayerType();
              if (layerType === LAYER_SUB || layerType === LAYER_SUB_AUDIO) {
                result = !!getLayerDuration(canvas.getLayerByType(LAYER_MAIN));
              } else {
                result = true;
              }
            } else {
              result = false;
            }
            break;
          case COMMANDS.GET_MAIN_LAYER_VOLUME:
            result = canvas.getMainLayerVolume();
            break;
          case COMMANDS.SET_MAIN_LAYER_VOLUME:
            canvas.setMainLayerVolume(args[0]);
            addUndo();
            saveOnline();
            break;
          case COMMANDS.CLEAR_IGNORES_RENDER:
            canvas.clearIgnoreRender();
            break;
          case COMMANDS.ADD_INTRO_ANIMATION_SLOT: {
            let graph = canvas.getSelectGraph();
            let name = args[0];
            if (graph) {
              graph.setAnimationSlot({
                id: FJViewConstant.INTRO,
                name,
                timeOffset: 0,
                duration: 1,
              });
            }
            break;
          }
          case COMMANDS.REMOVE_INTRO_ANIMATION_SLOT: {
            let graph = canvas.getSelectGraph();
            if (graph) {
              graph.setAnimationSlot({name: '', id: FJViewConstant.INTRO});
            }
            break;
          }
          case COMMANDS.ADD_OUTRO_ANIMATION_SLOT: {
            let graph = canvas.getSelectGraph();
            let name = args[0];
            if (graph) {
              graph.setAnimationSlot({
                id: FJViewConstant.OUTRO,
                name,
                timeOffset: graph.duration - 1,
                duration: 1,
              });
            }
            break;
          }
          case COMMANDS.REMOVE_OUTRO_ANIMATION_SLOT: {
            let graph = canvas.getSelectGraph();
            if (graph) {
              graph.setAnimationSlot({name: '', id: FJViewConstant.OUTRO});
            }
            break;
          }
          case COMMANDS.TOGGLE_EDIT_MODE: {
            let selectedGraph = canvas.getSelectGraph();
            if (selectedGraph) {
              if (FJConfig.enableMainTrackEditMode) {
                selectedGraph.setControlEnable(!selectedGraph.getControlEnable());
              }
              canvas.renderTrack();
            }
            break;
          }
          case COMMANDS.SET_TRANSFORM: {
            let type = args[0];
            let selectedId = args[1];
            let graph = canvas.getGraphById(selectedId);
            if (graph) {
              let transform_click_type = '';
              let angle = graph.getAngle();
              let {x: flipX, y: flipY} = graph.getFlip();
              switch (type) {
                case FJActionConstant.ROTATE_LEFT:
                  transform_click_type = 'rotate'
                  graph.setAngle(nearestAngleLevelWithDirection(angle, -1));
                  break;
                case FJActionConstant.ROTATE_RIGHT:
                  transform_click_type = 'rotate'
                  graph.setAngle(nearestAngleLevelWithDirection(angle, 1));
                  break;
                case FJActionConstant.FLIP_HORIZONTALLY:
                  transform_click_type = 'flip'
                  graph.setFlip({x: -flipX});
                  break;
                case FJActionConstant.FLIP_VERTICALLY:
                  transform_click_type = 'flip'
                  graph.setFlip({y: -flipY});
                  break;
              }
              FJUtil.ealog('timeline_tool_transform_click', {
                type: transform_click_type
              })
              canvas.render();
              addUndo(selectedId);
              saveOnline();
            }
            break;
          }
          case COMMANDS.DELETE_TRANSITION:
            decodeToTimeline();
            FJTimelineStore.deleteTransition(args[0]);
            encodeFromTimeline(true);
            canvas.reRender();
            addUndo();
            saveOnline();
            break;
          case COMMANDS.UPDATE_TRANSITION: {
            let transitionId = args[0];
            let transitionData = args[1];
            decodeToTimeline();
            FJTimelineStore.updateTransition(transitionId, transitionData, true);
            encodeFromTimeline(true);
            canvas.reRender();
            addUndo();
            saveOnline();
            break;
          }
          case COMMANDS.ABORT_DRAG_TRANSITION: {
            decodeToTimeline();
            result = FJTimelineStore.abortDragTransition()
            encodeFromTimeline();
            break;
          }
          case COMMANDS.DRAG_TRANSITION: {
            let name = args[0];
            let dragData = args[1];

            if (!name || !dragData) {
              return;
            }

            let {eventType,} = dragData;
            decodeToTimeline();
            result = FJTimelineStore.dragTransition(name, dragData)
            encodeFromTimeline(eventType === 'end');
            if (result.transition && eventType === 'end') {
              FJUtil.ealog('timeline_transition_use')
              addUndo();
              saveOnline();
              canvas.reRender();
            }
            break;
          }
          case COMMANDS.MOVE_OUT_TIMELINE_SPECIAL_TREATMENT:
            FJTimelineStore.moveOutSpecialTreatmentTimeline()
            break;
          case COMMANDS.RETRY_WATERMARK: {
            let watermark = canvas.getWatermark();
            let imageWatermark = watermark.getChild(FJCoreConstant.WATERMARK_IMAGE);
            if (imageWatermark && imageWatermark.sourceId) {
              updateServerSource(FJCoreConstant.WATERMARK_IMAGE, imageWatermark.sourceId);
            }
            break;
          }
          case COMMANDS.RENDER_CACHE:
            canvas.renderCache();
            break;
          case COMMANDS.ENABLE_FILTER: {
            let graph = canvas.getSelectGraph();
            let type = graph && graph.type;
            let {VIDEO, IMAGE} = FJConstant;
            if (type === VIDEO || type === IMAGE) {
              graph.enableFilter();
              addUndo(graph.id);
              saveOnline();
            }
            break;
          }
          case COMMANDS.SET_FILTER_DATA: {
            let data = args[0];
            let options = args[1];
            let graph = canvas.getSelectGraph();
            let type = graph && graph.type;
            let {VIDEO, IMAGE} = FJConstant;
            if (type === VIDEO || type === IMAGE) {

              if (!_.isUndefined(data.filterType)) {
                let intensity = ['black & white 1', 'black & white 4', 'sepia 1'].includes(data.filterType) ? 1 : 0.5;
                graph.setFilter({
                  type: data.filterType,
                  intensity: intensity,
                  active: true,
                });
                result = intensity;

                if (data.filterType !== 'none') {
                  FJUtil.ealog('timeline_filter_use', true);
                }
              }

              if (!_.isUndefined(data.intensity)) {
                graph.setFilter({
                  intensity: data.intensity,
                });

                if (!options || !options.type || (options && options.type === 'slideStop')) {
                  FJUtil.ealog('timeline_filter_use', true);
                }
              }

              if (!_.isUndefined(data.active)) {
                graph.setFilter({
                  active: data.active,
                });
              }

              if (data.apply) {
                let filter = data.filter;
                canvas.getAllGraphs()
                  .filter(graph => graph.type === VIDEO || graph.type === IMAGE)
                  .forEach(graph => {
                    graph.setFilter({...filter});
                  });
              }

              canvas.render();
              if (!options || !options.type || (options && options.type === 'slideStop')) {
                addUndo(graph.id);
                saveOnline();
              }
            }
            break;
          }
          case COMMANDS.SET_ADJUST_DATA: {
            let data = args[0];
            let options = args[1];
            let graph = canvas.getSelectGraph();
            let type = graph && graph.type;
            let {VIDEO, IMAGE} = FJConstant;
            if (type === VIDEO || type === IMAGE) {
              if (!_.isUndefined(data.active)) {
                graph.setAdjustFilter({
                  active: data.active,
                });
              }

              let adjustArray = ['exposure', 'brightness', 'temperature', 'tint', 'saturation', 'contrast', 'highlights', 'shadows', 'vignette'];
              if (adjustArray.some(value => !_.isUndefined(data[value]))) {
                graph.setAdjustFilter({...data});

                if (!options || !options.type || (options && options.type === 'slideStop')) {
                  FJUtil.ealog('timeline_adjust_use', true);
                }
              }

              if (data.apply) {
                let adjust = data.adjust;
                canvas.getAllGraphs()
                  .filter(graph => graph.type === VIDEO || graph.type === IMAGE)
                  .forEach(graph => {
                    graph.setAdjustFilter({...adjust});
                  });
              }

              if (data.reset) {
                let initData = {
                  exposure: 0,
                  brightness: 0,
                  temperature: 0,
                  tint: 0,
                  saturation: 0,
                  contrast: 0,
                  highlights: 0,
                  shadows: 0,
                  vignette: 0,
                };
                graph.setAdjustFilter(initData);
                result = initData;
              }

              canvas.render();
              if (!options || !options.type || (options && options.type === 'slideStop')) {
                addUndo(graph.id);
                saveOnline();
              }
            }
            break;
          }
          case COMMANDS.DECODE_MEDIA_TO_GRAPH:
            canvas.forEachGraph(graph => {
              decodeMediaToGraph(graph);
            });
            break;
          case COMMANDS.UPDATE_INTRO: {
            let intro = args[0];
            let videoName = args[1];
            let videoEditor = args[2];
            let introGraph = getIntroGraph();
            if (introGraph && introGraph.id === intro) {
              introGraph.updateTextData({videoName, videoEditor});
            }
            break;
          }
          case COMMANDS.DISABLE_INTRO:
            if (hasExportPreviewCanvas()) {
              decodeCanvas(canvas.encode(), true, exportPreviewCanvas);
              if (args[0]) exportPreviewCanvas.setSize(args[0]);
              exportPreviewCanvas.setMaxLimitTime(FJConfig.maxLimitTime);
            }
            break;
          case COMMANDS.SET_EDITOR:
            canvas.setEditor(args[0]);
            if (hasExportPreviewCanvas()) {
              exportPreviewCanvas.setEditor(args[0]);
            }
            saveOnline();
            break;
          case COMMANDS.SHARE_TO_DROPBOX_CANCEL:
            FJShareStore.stopShareToDropbox();
            break;
          case COMMANDS.SET_EXPORT_PREVIEW_GLOBAL_VOLUME:
            if (hasExportPreviewCanvas()) {
              let volume = args[0];
              let {shouldCache, useCache} = args[1] || {};
              if (shouldCache) {
                _globalVolumeCache = volume;
              }
              exportPreviewCanvas.setGlobalVolume(useCache ? _globalVolumeCache : volume);
            }
            break;
          case COMMANDS.GET_RATIO: {
            result = canvas.getRatioType();
            break;
          }
          case COMMANDS.SET_RATIO: {
            let ratioType = args[0];
            let preRatioType = canvas.getRatioType();
            let graph = canvas.getSelectGraph();
            canvas.setRatioType(ratioType);
            canvas.updateAllGraphByRatioChanged(preRatioType, ratioType);
            addUndo(graph && graph.id);
            saveOnline();
            break;
          }
          case COMMANDS.BIND_EXPORT_PREVIEW:
            if (!hasExportPreviewCanvas()) {
              exportPreviewCanvas = new FJAnimationCanvas();
              exportPreviewCanvas.bindCanvas(args[0], {
                withContentView: true,
                withWatermarkView: true,
                withTrackView: false,
                withUpperView: false,
              });
            }
            break;
          case COMMANDS.UNBIND_EXPORT_PREVIEW:
            exportPreviewCanvas.pause();
            exportPreviewCanvas.clearCanvas(true);
            exportPreviewCanvas.removeAll();
            exportPreviewCanvas = null;
            break;
          case COMMANDS.HAS_EXPORT_PREVIEW:
            result = hasExportPreviewCanvas();
            break;
          default:
        }

        return result;
      } catch (e) {
        console.log(e);
      }
    },

    /**
     * @description 返回可操作类型
     * @return {Object}
     */
    get command() {
      return COMMANDS;
    }
  }
})();

export default FJCanvasStore;
